var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgPattern3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2226,
    height: 1145,
    viewBox: "0 0 2226 1145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1912.09 446.601L1912.03 447.267L1939.5 450.353L2056.01 357.368L2059.6 325.499L2123.44 274.549L2122.61 264.766L2157.87 236.629L2157.46 236.104L2121.9 264.464L2122.73 274.246L2058.95 325.156L2055.38 357.025L1939.3 449.647L1912.09 446.601Z",
    fill: "url(#paint0_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2158.25 237.193C2158.69 236.85 2158.75 236.205 2158.41 235.761C2158.07 235.317 2157.42 235.257 2156.98 235.6C2156.54 235.942 2156.47 236.588 2156.82 237.032C2157.18 237.455 2157.83 237.536 2158.25 237.193Z",
    fill: "url(#paint1_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1911.99 447.953C1911.43 447.892 1911.04 447.388 1911.1 446.823C1911.16 446.259 1911.67 445.875 1912.23 445.936C1912.8 445.996 1913.18 446.501 1913.12 447.066C1913.06 447.61 1912.56 448.014 1911.99 447.953Z",
    fill: "url(#paint2_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1970.59 492.65L1967.88 516.814L1968.55 516.894L1971.23 492.992L2060.08 422.094L2106.13 427.258L2186.45 363.156L2189.37 337.177L2219.16 313.417L2218.74 312.892L2188.73 336.834L2185.82 362.793L2105.93 426.552L2059.88 421.388L1970.59 492.65Z",
    fill: "url(#paint3_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2219.55 313.981C2219.99 313.638 2220.05 312.993 2219.71 312.549C2219.37 312.105 2218.72 312.045 2218.28 312.388C2217.83 312.731 2217.77 313.376 2218.12 313.82C2218.46 314.243 2219.1 314.324 2219.55 313.981Z",
    fill: "url(#paint4_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1969.21 516.914C1969.15 517.478 1968.65 517.862 1968.08 517.801C1967.52 517.741 1967.14 517.236 1967.2 516.672C1967.26 516.107 1967.76 515.724 1968.33 515.784C1968.89 515.865 1969.29 516.349 1969.21 516.914Z",
    fill: "url(#paint5_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1887.48 481.234L1887.42 481.899L1899.69 483.271L1921.89 465.561L1938.62 467.437L2068.63 363.681L2072.12 332.579L2130.33 286.127L2132.19 269.607L2171.6 238.142L2171.18 237.617L2131.56 269.244L2129.71 285.764L2071.48 332.236L2067.99 363.318L1938.41 466.731L1921.69 464.856L1899.49 482.585L1887.48 481.234Z",
    fill: "url(#paint6_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2171.99 238.706C2172.43 238.363 2172.49 237.718 2172.15 237.274C2171.8 236.83 2171.16 236.77 2170.71 237.113C2170.27 237.456 2170.21 238.101 2170.55 238.545C2170.92 238.989 2171.56 239.049 2171.99 238.706Z",
    fill: "url(#paint7_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1887.38 482.585C1886.82 482.524 1886.44 482.02 1886.5 481.455C1886.56 480.89 1887.06 480.507 1887.63 480.568C1888.19 480.628 1888.57 481.133 1888.51 481.697C1888.45 482.242 1887.95 482.645 1887.38 482.585Z",
    fill: "url(#paint8_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1920.36 534.341L1918.79 548.441L1919.45 548.521L1921.01 534.684L1958.99 504.389L1961.39 482.948L2054.19 408.882L2104.17 414.49L2176.6 356.682L2178.82 336.996L2225.24 299.963L2224.81 299.438L2178.18 336.653L2175.98 356.319L2103.97 413.784L2053.99 408.176L1960.74 482.585L1958.34 504.046L1920.36 534.341Z",
    fill: "url(#paint9_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225.62 300.528C2226.06 300.185 2226.12 299.54 2225.78 299.096C2225.44 298.652 2224.79 298.592 2224.35 298.935C2223.9 299.277 2223.84 299.923 2224.19 300.367C2224.55 300.79 2225.17 300.871 2225.62 300.528Z",
    fill: "url(#paint10_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1920.14 548.541C1920.08 549.106 1919.57 549.489 1919.01 549.429C1918.45 549.368 1918.06 548.864 1918.12 548.299C1918.18 547.734 1918.69 547.351 1919.25 547.412C1919.8 547.492 1920.2 547.996 1920.14 548.541Z",
    fill: "url(#paint11_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1946 479.66L1944.4 493.941L1945.07 494.022L1946.64 480.023L2049.59 397.87L2097.07 403.195L2160.02 352.971L2162.08 334.596L2212.59 294.295L2212.16 293.771L2161.46 334.233L2159.4 352.608L2096.87 402.509L2049.39 397.164L1946 479.66Z",
    fill: "url(#paint12_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2212.97 294.84C2213.42 294.497 2213.48 293.852 2213.13 293.408C2212.79 292.964 2212.14 292.904 2211.7 293.247C2211.26 293.589 2211.2 294.235 2211.54 294.679C2211.9 295.122 2212.55 295.203 2212.97 294.84Z",
    fill: "url(#paint13_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1945.76 494.042C1945.7 494.607 1945.19 494.99 1944.63 494.93C1944.06 494.869 1943.68 494.365 1943.74 493.8C1943.8 493.235 1944.3 492.852 1944.87 492.913C1945.41 492.973 1945.82 493.477 1945.76 494.042Z",
    fill: "url(#paint14_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2089.65 337.076L2090.07 337.601L2137.15 300.044L2140.32 271.704L2182.37 238.161L2181.95 237.637L2139.69 271.361L2136.51 299.68L2089.65 337.076Z",
    fill: "url(#paint15_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2182.76 238.726C2183.2 238.383 2183.26 237.737 2182.92 237.294C2182.58 236.85 2181.93 236.789 2181.49 237.132C2181.04 237.475 2180.98 238.121 2181.32 238.564C2181.67 239.008 2182.31 239.069 2182.76 238.726Z",
    fill: "url(#paint16_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2090.54 338.105C2090.09 338.448 2089.47 338.387 2089.11 337.943C2088.76 337.5 2088.82 336.874 2089.27 336.511C2089.71 336.168 2090.34 336.229 2090.7 336.673C2091.04 337.116 2090.98 337.762 2090.54 338.105Z",
    fill: "url(#paint17_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2076.9 370.197L2077.33 370.721L2147.88 314.406L2151.78 279.774L2181.85 255.771L2181.43 255.247L2151.13 279.411L2147.24 314.043L2076.9 370.197Z",
    fill: "url(#paint18_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2182.23 256.335C2182.68 255.992 2182.74 255.347 2182.39 254.903C2182.05 254.459 2181.41 254.399 2180.96 254.742C2180.52 255.085 2180.46 255.73 2180.8 256.174C2181.14 256.617 2181.79 256.678 2182.23 256.335Z",
    fill: "url(#paint19_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077.79 371.205C2077.35 371.548 2076.72 371.488 2076.36 371.044C2076.02 370.6 2076.08 369.975 2076.52 369.612C2076.96 369.269 2077.59 369.329 2077.95 369.773C2078.29 370.217 2078.21 370.862 2077.79 371.205Z",
    fill: "url(#paint20_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080.57 379.959L2080.51 380.624L2099.9 382.803L2146.51 345.589L2148.1 331.429L2203.27 287.397L2202.85 286.873L2147.46 331.086L2145.87 345.246L2099.7 382.097L2080.57 379.959Z",
    fill: "url(#paint21_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2203.65 287.962C2204.1 287.619 2204.16 286.973 2203.81 286.529C2203.47 286.086 2202.83 286.025 2202.38 286.368C2201.94 286.711 2201.88 287.356 2202.22 287.8C2202.56 288.244 2203.21 288.304 2203.65 287.962Z",
    fill: "url(#paint22_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2080.47 381.31C2079.91 381.249 2079.53 380.745 2079.59 380.18C2079.65 379.616 2080.15 379.232 2080.72 379.293C2081.28 379.353 2081.66 379.858 2081.6 380.422C2081.54 380.967 2081.04 381.37 2080.47 381.31Z",
    fill: "url(#paint23_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2159.48 304.502L2160.15 304.583L2161.56 292.037L2188.71 270.354L2188.28 269.83L2160.91 291.674L2159.48 304.502Z",
    fill: "url(#paint24_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2189.09 270.918C2189.53 270.575 2189.59 269.93 2189.25 269.486C2188.91 269.042 2188.26 268.982 2187.82 269.325C2187.38 269.668 2187.32 270.313 2187.66 270.757C2188.02 271.2 2188.65 271.261 2189.09 270.918Z",
    fill: "url(#paint25_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2160.83 304.603C2160.77 305.167 2160.27 305.551 2159.7 305.49C2159.14 305.43 2158.75 304.925 2158.81 304.361C2158.88 303.796 2159.38 303.413 2159.94 303.473C2160.49 303.534 2160.89 304.038 2160.83 304.603Z",
    fill: "url(#paint26_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1918.91 422.498L1918.83 423.164L1947.91 426.432L2047.11 347.263L2050.58 316.282L2101.81 275.396L2101.39 274.872L2049.96 315.919L2046.47 346.9L1947.71 425.726L1918.91 422.498Z",
    fill: "url(#paint27_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2102.2 275.961C2102.64 275.618 2102.7 274.973 2102.36 274.529C2102.02 274.085 2101.37 274.025 2100.93 274.368C2100.48 274.711 2100.42 275.356 2100.76 275.8C2101.13 276.223 2101.77 276.304 2102.2 275.961Z",
    fill: "url(#paint28_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1918.81 423.829C1918.24 423.768 1917.86 423.264 1917.92 422.699C1917.98 422.135 1918.49 421.751 1919.05 421.812C1919.62 421.872 1920 422.377 1919.94 422.941C1919.86 423.506 1919.35 423.889 1918.81 423.829Z",
    fill: "url(#paint29_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1944.53 410.558L1944.95 411.082L2034.81 339.377L2034.38 338.832L1944.53 410.558Z",
    fill: "url(#paint30_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2035.19 339.921C2035.63 339.578 2035.69 338.932 2035.35 338.488C2035.01 338.045 2034.36 337.984 2033.92 338.327C2033.48 338.67 2033.42 339.315 2033.76 339.759C2034.12 340.203 2034.75 340.284 2035.19 339.921Z",
    fill: "url(#paint31_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1945.41 411.585C1944.97 411.928 1944.34 411.868 1943.98 411.424C1943.64 410.98 1943.7 410.355 1944.14 409.992C1944.59 409.649 1945.21 409.709 1945.57 410.153C1945.92 410.597 1945.84 411.222 1945.41 411.585Z",
    fill: "url(#paint32_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2124.91 226.099L2124.97 225.434L2097.5 222.348L1980.99 315.333L1977.4 347.202L1913.56 398.152L1914.39 407.934L1879.13 436.072L1879.56 436.596L1915.1 408.237L1914.27 398.454L1978.05 347.545L1981.62 315.676L2097.7 223.054L2124.91 226.099Z",
    fill: "url(#paint33_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1878.75 435.506C1878.31 435.849 1878.25 436.495 1878.59 436.938C1878.93 437.382 1879.58 437.443 1880.02 437.1C1880.46 436.757 1880.53 436.111 1880.18 435.668C1879.82 435.244 1879.17 435.163 1878.75 435.506Z",
    fill: "url(#paint34_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2125.01 224.748C2125.57 224.809 2125.96 225.313 2125.9 225.878C2125.84 226.443 2125.33 226.826 2124.77 226.765C2124.2 226.705 2123.82 226.2 2123.88 225.636C2123.94 225.091 2124.44 224.688 2125.01 224.748Z",
    fill: "url(#paint35_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2066.41 180.051L2069.12 155.887L2068.45 155.807L2065.77 179.708L1976.92 250.627L1930.87 245.443L1850.55 309.544L1847.63 335.524L1817.86 359.284L1818.26 359.809L1848.27 335.867L1851.18 309.908L1931.07 246.149L1977.12 251.313L2066.41 180.051Z",
    fill: "url(#paint36_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1817.47 358.72C1817.03 359.063 1816.97 359.708 1817.31 360.152C1817.65 360.596 1818.3 360.656 1818.74 360.313C1819.19 359.97 1819.25 359.325 1818.91 358.881C1818.54 358.458 1817.9 358.377 1817.47 358.72Z",
    fill: "url(#paint37_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2067.79 155.786C2067.85 155.222 2068.35 154.838 2068.92 154.899C2069.48 154.959 2069.86 155.464 2069.8 156.028C2069.74 156.593 2069.24 156.976 2068.67 156.916C2068.11 156.835 2067.71 156.351 2067.79 155.786Z",
    fill: "url(#paint38_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2149.52 191.467L2149.58 190.802L2137.31 189.43L2115.11 207.14L2098.38 205.264L1968.37 309.02L1964.88 340.122L1906.67 386.574L1904.81 403.094L1865.4 434.56L1865.82 435.084L1905.44 403.457L1907.29 386.938L1965.52 340.465L1969.01 309.383L2098.59 205.97L2115.31 207.846L2137.51 190.116L2149.52 191.467Z",
    fill: "url(#paint39_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1865.01 433.994C1864.57 434.337 1864.51 434.982 1864.85 435.426C1865.2 435.87 1865.84 435.93 1866.28 435.588C1866.73 435.245 1866.79 434.599 1866.45 434.155C1866.08 433.712 1865.46 433.651 1865.01 433.994Z",
    fill: "url(#paint40_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2149.62 190.116C2150.18 190.176 2150.56 190.681 2150.5 191.245C2150.44 191.81 2149.94 192.193 2149.37 192.133C2148.81 192.072 2148.43 191.568 2148.49 191.003C2148.55 190.459 2149.05 190.055 2149.62 190.116Z",
    fill: "url(#paint41_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2116.64 138.358L2118.21 124.259L2117.55 124.179L2115.99 138.016L2078.01 168.311L2075.61 189.752L1982.81 263.818L1932.83 258.21L1860.4 316.018L1858.18 335.704L1811.76 372.737L1812.19 373.261L1858.82 336.047L1861.02 316.381L1933.03 258.916L1983.01 264.523L2076.26 190.115L2078.66 168.674L2116.64 138.358Z",
    fill: "url(#paint42_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1811.38 372.172C1810.94 372.515 1810.88 373.161 1811.22 373.604C1811.56 374.048 1812.21 374.109 1812.65 373.766C1813.1 373.423 1813.16 372.777 1812.81 372.334C1812.45 371.91 1811.83 371.829 1811.38 372.172Z",
    fill: "url(#paint43_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2116.88 124.159C2116.94 123.594 2117.45 123.211 2118.01 123.271C2118.57 123.332 2118.96 123.836 2118.9 124.401C2118.84 124.966 2118.33 125.349 2117.77 125.288C2117.2 125.208 2116.8 124.704 2116.88 124.159Z",
    fill: "url(#paint44_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2091 193.04L2092.6 178.76L2091.93 178.679L2090.36 192.677L1987.43 274.831L1939.93 269.506L1876.98 319.73L1874.92 338.105L1824.41 378.405L1824.84 378.95L1875.54 338.468L1877.62 320.093L1940.13 270.192L1987.63 275.537L2091 193.04Z",
    fill: "url(#paint45_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1824.03 377.861C1823.58 378.204 1823.52 378.849 1823.87 379.293C1824.21 379.737 1824.86 379.797 1825.3 379.454C1825.74 379.112 1825.8 378.466 1825.46 378.022C1825.1 377.579 1824.47 377.498 1824.03 377.861Z",
    fill: "url(#paint46_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2091.24 178.659C2091.3 178.094 2091.81 177.711 2092.37 177.771C2092.94 177.832 2093.32 178.336 2093.26 178.901C2093.2 179.466 2092.7 179.849 2092.13 179.788C2091.59 179.728 2091.18 179.224 2091.24 178.659Z",
    fill: "url(#paint47_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1947.35 335.625L1946.93 335.1L1899.85 372.657L1896.68 400.996L1854.63 434.54L1855.05 435.064L1897.31 401.339L1900.49 373.02L1947.35 335.625Z",
    fill: "url(#paint48_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1854.24 433.975C1853.8 434.317 1853.74 434.963 1854.08 435.407C1854.42 435.85 1855.07 435.911 1855.51 435.568C1855.96 435.225 1856.02 434.58 1855.68 434.136C1855.33 433.692 1854.69 433.632 1854.24 433.975Z",
    fill: "url(#paint49_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1946.46 334.595C1946.91 334.252 1947.53 334.313 1947.89 334.757C1948.24 335.2 1948.18 335.826 1947.73 336.189C1947.29 336.532 1946.66 336.471 1946.3 336.027C1945.96 335.584 1946.02 334.938 1946.46 334.595Z",
    fill: "url(#paint50_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1960.1 302.504L1959.67 301.98L1889.12 358.295L1885.23 392.928L1855.15 416.93L1855.57 417.455L1885.87 393.291L1889.76 358.658L1960.1 302.504Z",
    fill: "url(#paint51_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1854.77 416.366C1854.32 416.709 1854.26 417.354 1854.61 417.798C1854.95 418.242 1855.59 418.302 1856.04 417.96C1856.48 417.617 1856.54 416.971 1856.2 416.528C1855.86 416.084 1855.21 416.023 1854.77 416.366Z",
    fill: "url(#paint52_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1959.21 301.496C1959.65 301.153 1960.28 301.214 1960.64 301.657C1960.98 302.101 1960.92 302.726 1960.48 303.09C1960.04 303.432 1959.41 303.372 1959.05 302.928C1958.71 302.484 1958.79 301.839 1959.21 301.496Z",
    fill: "url(#paint53_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1956.43 292.742L1956.51 292.077L1937.1 289.898L1890.49 327.113L1888.9 341.272L1833.73 385.304L1834.15 385.828L1889.54 341.635L1891.13 327.455L1937.32 290.604L1956.43 292.742Z",
    fill: "url(#paint54_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1833.35 384.739C1832.9 385.082 1832.84 385.727 1833.19 386.171C1833.53 386.615 1834.17 386.675 1834.62 386.332C1835.06 385.989 1835.12 385.344 1834.78 384.9C1834.44 384.456 1833.79 384.396 1833.35 384.739Z",
    fill: "url(#paint55_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1956.53 291.39C1957.09 291.451 1957.48 291.955 1957.41 292.52C1957.35 293.085 1956.85 293.468 1956.29 293.407C1955.72 293.347 1955.34 292.843 1955.4 292.278C1955.46 291.733 1955.96 291.33 1956.53 291.39Z",
    fill: "url(#paint56_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1877.52 368.199L1876.85 368.118L1875.44 380.664L1848.29 402.347L1848.72 402.872L1876.09 381.027L1877.52 368.199Z",
    fill: "url(#paint57_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1847.91 401.783C1847.47 402.126 1847.41 402.772 1847.75 403.215C1848.09 403.659 1848.74 403.72 1849.18 403.377C1849.62 403.034 1849.68 402.388 1849.34 401.945C1848.98 401.501 1848.35 401.44 1847.91 401.783Z",
    fill: "url(#paint58_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1876.19 368.098C1876.25 367.533 1876.75 367.15 1877.32 367.21C1877.88 367.271 1878.27 367.775 1878.21 368.34C1878.15 368.905 1877.64 369.288 1877.08 369.227C1876.51 369.167 1876.11 368.663 1876.19 368.098Z",
    fill: "url(#paint59_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2118.09 250.222L2118.17 249.537L2089.09 246.269L1989.89 325.437L1986.42 356.419L1935.19 397.304L1935.61 397.829L1987.04 356.782L1990.53 325.8L2089.29 246.975L2118.09 250.222Z",
    fill: "url(#paint60_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1934.8 396.74C1934.36 397.083 1934.3 397.728 1934.64 398.172C1934.98 398.616 1935.63 398.676 1936.07 398.333C1936.52 397.99 1936.58 397.345 1936.24 396.901C1935.87 396.478 1935.25 396.397 1934.8 396.74Z",
    fill: "url(#paint61_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2118.19 248.872C2118.76 248.932 2119.14 249.436 2119.08 250.001C2119.02 250.566 2118.51 250.949 2117.95 250.889C2117.38 250.828 2117 250.324 2117.06 249.759C2117.14 249.194 2117.65 248.811 2118.19 248.872Z",
    fill: "url(#paint62_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2092.47 262.144L2092.05 261.62L2002.19 333.325L2002.62 333.87L2092.47 262.144Z",
    fill: "url(#paint63_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2001.81 332.78C2001.37 333.123 2001.3 333.769 2001.65 334.212C2001.99 334.656 2002.64 334.717 2003.08 334.374C2003.52 334.031 2003.58 333.386 2003.24 332.942C2002.9 332.498 2002.25 332.417 2001.81 332.78Z",
    fill: "url(#paint64_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2091.59 261.115C2092.03 260.772 2092.66 260.832 2093.02 261.276C2093.36 261.72 2093.3 262.345 2092.86 262.708C2092.41 263.051 2091.79 262.991 2091.43 262.547C2091.08 262.103 2091.16 261.478 2091.59 261.115Z",
    fill: "url(#paint65_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1875.24 603.399L1874.57 603.369L1872.71 630.951L1970.79 743.195L2002.79 745.362L2056.53 806.867L2066.27 805.605L2095.95 839.574L2096.46 839.148L2066.54 804.887L2056.81 806.149L2003.1 744.702L1971.11 742.555L1873.41 630.718L1875.24 603.399Z",
    fill: "url(#paint66_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2095.4 839.982C2095.77 840.41 2096.41 840.442 2096.84 840.079C2097.27 839.717 2097.3 839.069 2096.94 838.641C2096.58 838.213 2095.93 838.182 2095.5 838.544C2095.09 838.926 2095.04 839.574 2095.4 839.982Z",
    fill: "url(#paint67_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1873.88 603.359C1873.92 602.792 1874.4 602.387 1874.97 602.422C1875.54 602.457 1875.94 602.944 1875.91 603.511C1875.87 604.078 1875.39 604.483 1874.82 604.448C1874.27 604.411 1873.85 603.926 1873.88 603.359Z",
    fill: "url(#paint68_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1831.84 663.887L1807.58 662.264L1807.53 662.932L1831.53 664.547L1906.31 750.15L1903.21 796.383L1970.82 873.765L1996.91 875.529L2021.97 904.232L2022.48 903.786L1997.22 874.869L1971.16 873.124L1903.9 796.15L1907.01 749.917L1831.84 663.887Z",
    fill: "url(#paint69_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2021.42 904.64C2021.79 905.068 2022.43 905.1 2022.86 904.737C2023.29 904.375 2023.32 903.728 2022.96 903.3C2022.6 902.872 2021.95 902.84 2021.52 903.202C2021.11 903.564 2021.06 904.212 2021.42 904.64Z",
    fill: "url(#paint70_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1807.54 663.598C1806.97 663.563 1806.57 663.076 1806.6 662.509C1806.64 661.942 1807.12 661.537 1807.69 661.572C1808.26 661.607 1808.66 662.094 1808.63 662.661C1808.57 663.229 1808.11 663.653 1807.54 663.598Z",
    fill: "url(#paint71_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1839.54 580.359L1838.87 580.328L1838.05 592.64L1856.73 614.037L1855.6 630.825L1965.05 756.09L1996.28 758.19L2045.28 814.274L2061.86 815.392L2095.05 853.363L2095.56 852.917L2062.2 814.751L2045.61 813.633L1996.59 757.53L1965.38 755.429L1856.3 630.592L1857.43 613.804L1838.73 592.408L1839.54 580.359Z",
    fill: "url(#paint72_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2094.51 853.771C2094.87 854.199 2095.51 854.231 2095.94 853.869C2096.37 853.507 2096.4 852.859 2096.04 852.431C2095.68 852.003 2095.03 851.971 2094.6 852.334C2094.18 852.716 2094.14 853.364 2094.51 853.771Z",
    fill: "url(#paint73_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1838.19 580.318C1838.22 579.751 1838.71 579.346 1839.28 579.381C1839.84 579.417 1840.25 579.903 1840.21 580.47C1840.18 581.037 1839.69 581.442 1839.12 581.407C1838.58 581.371 1838.15 580.885 1838.19 580.318Z",
    fill: "url(#paint74_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1787.95 615.57L1773.8 614.627L1773.75 615.295L1787.64 616.23L1819.6 652.823L1841.12 654.266L1919.25 743.677L1915.87 793.859L1976.85 863.643L1996.62 864.982L2035.68 909.698L2036.19 909.251L1996.93 864.322L1977.19 863.002L1916.57 793.626L1919.95 743.444L1841.46 653.605L1819.91 652.163L1787.95 615.57Z",
    fill: "url(#paint75_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2035.13 910.106C2035.5 910.534 2036.14 910.566 2036.57 910.203C2037 909.841 2037.03 909.193 2036.67 908.765C2036.31 908.337 2035.66 908.306 2035.23 908.668C2034.82 909.05 2034.77 909.678 2035.13 910.106Z",
    fill: "url(#paint76_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1773.76 615.982C1773.19 615.946 1772.78 615.46 1772.82 614.893C1772.85 614.326 1773.34 613.921 1773.91 613.956C1774.48 613.991 1774.88 614.478 1774.85 615.045C1774.79 615.592 1774.3 616.018 1773.76 615.982Z",
    fill: "url(#paint77_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1843.72 638.745L1829.38 637.789L1829.33 638.458L1843.39 639.406L1930.05 738.592L1926.84 786.263L1979.82 846.914L1998.27 848.15L2040.78 896.811L2041.29 896.364L1998.6 847.51L1980.16 846.273L1927.52 786.031L1930.74 738.359L1843.72 638.745Z",
    fill: "url(#paint78_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2040.25 897.218C2040.62 897.646 2041.26 897.678 2041.69 897.316C2042.12 896.953 2042.15 896.306 2041.79 895.878C2041.43 895.45 2040.78 895.418 2040.35 895.78C2039.92 896.163 2039.87 896.811 2040.25 897.218Z",
    fill: "url(#paint79_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1829.34 639.144C1828.78 639.108 1828.37 638.622 1828.41 638.055C1828.44 637.488 1828.93 637.083 1829.49 637.118C1830.06 637.153 1830.47 637.64 1830.43 638.207C1830.39 638.754 1829.91 639.179 1829.34 639.144Z",
    fill: "url(#paint80_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1992.56 775.901L1992.06 776.348L2031.68 821.705L2060.13 823.606L2095.51 864.124L2096.02 863.678L2060.44 822.966L2032.01 821.044L1992.56 775.901Z",
    fill: "url(#paint81_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2094.97 864.533C2095.33 864.961 2095.97 864.992 2096.4 864.63C2096.83 864.268 2096.86 863.62 2096.5 863.192C2096.14 862.764 2095.49 862.732 2095.06 863.095C2094.63 863.457 2094.6 864.105 2094.97 864.533Z",
    fill: "url(#paint82_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1991.58 776.834C1991.21 776.406 1991.25 775.779 1991.67 775.396C1992.1 775.034 1992.73 775.066 1993.11 775.493C1993.47 775.921 1993.44 776.549 1993.01 776.931C1992.59 777.294 1991.94 777.262 1991.58 776.834Z",
    fill: "url(#paint83_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1958.91 764.642L1958.4 765.089L2017.81 833.065L2052.58 835.411L2077.9 864.385L2078.4 863.939L2052.91 834.75L2018.14 832.404L1958.91 764.642Z",
    fill: "url(#paint84_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2077.35 864.793C2077.71 865.221 2078.36 865.253 2078.79 864.891C2079.22 864.528 2079.25 863.881 2078.89 863.453C2078.52 863.025 2077.88 862.993 2077.45 863.356C2077.02 863.718 2076.99 864.365 2077.35 864.793Z",
    fill: "url(#paint85_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1957.94 765.574C1957.58 765.146 1957.61 764.518 1958.04 764.136C1958.47 763.773 1959.09 763.806 1959.48 764.233C1959.84 764.661 1959.81 765.289 1959.38 765.671C1958.95 766.033 1958.3 765.982 1957.94 765.574Z",
    fill: "url(#paint86_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1949.32 768.744L1948.65 768.713L1947.34 788.175L1986.59 833.084L2000.81 834.045L2047.26 887.194L2047.76 886.747L2001.12 833.385L1986.91 832.424L1948.04 787.942L1949.32 768.744Z",
    fill: "url(#paint87_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2046.71 887.602C2047.07 888.03 2047.72 888.062 2048.15 887.699C2048.58 887.337 2048.61 886.69 2048.25 886.262C2047.88 885.834 2047.24 885.802 2046.81 886.164C2046.38 886.526 2046.35 887.174 2046.71 887.602Z",
    fill: "url(#paint88_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1947.97 768.704C1948 768.137 1948.49 767.732 1949.05 767.767C1949.62 767.802 1950.03 768.289 1949.99 768.856C1949.96 769.423 1949.47 769.828 1948.9 769.793C1948.36 769.757 1947.93 769.271 1947.97 768.704Z",
    fill: "url(#paint89_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2028.22 844.211L2028.17 844.879L2040.76 845.731L2063.63 871.887L2064.14 871.44L2041.1 845.07L2028.22 844.211Z",
    fill: "url(#paint90_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2063.09 872.294C2063.45 872.722 2064.1 872.754 2064.53 872.392C2064.95 872.029 2064.98 871.382 2064.62 870.954C2064.26 870.526 2063.61 870.494 2063.18 870.857C2062.76 871.239 2062.72 871.866 2063.09 872.294Z",
    fill: "url(#paint91_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2028.18 845.565C2027.61 845.53 2027.2 845.043 2027.24 844.476C2027.28 843.909 2027.76 843.504 2028.33 843.539C2028.9 843.575 2029.3 844.061 2029.27 844.628C2029.23 845.175 2028.74 845.6 2028.18 845.565Z",
    fill: "url(#paint92_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1899.62 609.136L1898.95 609.085L1896.98 638.287L1980.49 733.858L2011.6 735.944L2054.72 785.304L2055.23 784.857L2011.93 735.303L1980.83 733.197L1897.68 638.054L1899.62 609.136Z",
    fill: "url(#paint93_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2054.18 785.712C2054.54 786.14 2055.19 786.172 2055.62 785.809C2056.04 785.447 2056.08 784.799 2055.71 784.371C2055.35 783.943 2054.7 783.912 2054.27 784.274C2053.87 784.656 2053.82 785.304 2054.18 785.712Z",
    fill: "url(#paint94_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1898.29 609.095C1898.32 608.528 1898.81 608.122 1899.37 608.158C1899.94 608.193 1900.35 608.68 1900.31 609.247C1900.28 609.813 1899.79 610.219 1899.22 610.184C1898.65 610.128 1898.25 609.641 1898.29 609.095Z",
    fill: "url(#paint95_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1912.69 634.194L1912.18 634.641L1987.82 721.215L1988.35 720.768L1912.69 634.194Z",
    fill: "url(#paint96_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1987.3 721.623C1987.66 722.051 1988.31 722.082 1988.73 721.72C1989.16 721.358 1989.19 720.71 1988.83 720.282C1988.47 719.854 1987.82 719.822 1987.39 720.185C1986.97 720.567 1986.91 721.195 1987.3 721.623Z",
    fill: "url(#paint97_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1911.7 635.127C1911.34 634.699 1911.37 634.071 1911.8 633.689C1912.23 633.327 1912.85 633.359 1913.24 633.786C1913.6 634.214 1913.57 634.842 1913.14 635.224C1912.71 635.587 1912.08 635.534 1911.7 635.127Z",
    fill: "url(#paint98_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2105 806.179L2105.67 806.21L2107.53 778.628L2009.44 666.383L1977.45 664.216L1923.7 602.711L1913.97 603.973L1884.29 570.004L1883.78 570.451L1913.7 604.692L1923.43 603.43L1977.13 664.876L2009.13 667.023L2106.83 778.861L2105 806.179Z",
    fill: "url(#paint99_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1884.83 569.596C1884.47 569.168 1883.82 569.136 1883.4 569.499C1882.97 569.861 1882.94 570.509 1883.3 570.937C1883.66 571.365 1884.31 571.396 1884.74 571.034C1885.14 570.652 1885.2 570.004 1884.83 569.596Z",
    fill: "url(#paint100_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2106.36 806.219C2106.32 806.786 2105.83 807.191 2105.27 807.156C2104.7 807.121 2104.29 806.634 2104.33 806.067C2104.37 805.5 2104.85 805.095 2105.42 805.13C2105.97 805.167 2106.39 805.652 2106.36 806.219Z",
    fill: "url(#paint101_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2148.4 745.691L2172.66 747.315L2172.71 746.646L2148.71 745.031L2073.9 659.429L2077.03 613.195L2009.41 535.813L1983.33 534.049L1958.27 505.366L1957.76 505.792L1983.02 534.709L2009.08 536.454L2076.33 613.428L2073.23 659.661L2148.4 745.691Z",
    fill: "url(#paint102_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1958.81 504.958C1958.45 504.53 1957.8 504.498 1957.38 504.861C1956.95 505.223 1956.92 505.87 1957.28 506.298C1957.64 506.727 1958.29 506.758 1958.72 506.396C1959.12 506.014 1959.18 505.366 1958.81 504.958Z",
    fill: "url(#paint103_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2172.7 745.98C2173.27 746.016 2173.67 746.502 2173.64 747.069C2173.6 747.636 2173.11 748.042 2172.55 748.006C2171.98 747.971 2171.58 747.484 2171.61 746.917C2171.67 746.35 2172.13 745.925 2172.7 745.98Z",
    fill: "url(#paint104_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2140.7 829.219L2141.36 829.25L2142.19 816.938L2123.51 795.541L2124.63 778.753L2015.19 653.488L1983.96 651.388L1934.96 595.304L1918.38 594.186L1885.18 556.215L1884.68 556.661L1918.04 594.827L1934.63 595.945L1983.65 652.048L2014.85 654.149L2123.94 778.986L2122.81 795.774L2141.51 817.17L2140.7 829.219Z",
    fill: "url(#paint105_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1885.73 555.806C1885.37 555.378 1884.72 555.347 1884.29 555.709C1883.87 556.071 1883.84 556.719 1884.2 557.147C1884.56 557.575 1885.21 557.607 1885.64 557.244C1886.06 556.862 1886.1 556.234 1885.73 555.806Z",
    fill: "url(#paint106_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2142.05 829.26C2142.01 829.827 2141.53 830.232 2140.96 830.197C2140.39 830.161 2139.99 829.675 2140.02 829.108C2140.06 828.541 2140.55 828.136 2141.11 828.171C2141.66 828.207 2142.09 828.693 2142.05 829.26Z",
    fill: "url(#paint107_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2192.29 794.008L2206.44 794.952L2206.49 794.283L2192.6 793.348L2160.64 756.755L2139.12 755.313L2060.99 665.902L2064.36 615.72L2003.39 545.936L1983.62 544.597L1944.56 499.881L1944.05 500.327L1983.31 545.257L2003.05 546.577L2063.67 615.953L2060.29 666.135L2138.78 755.974L2160.31 757.416L2192.29 794.008Z",
    fill: "url(#paint108_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1945.1 499.473C1944.74 499.045 1944.09 499.013 1943.67 499.375C1943.24 499.738 1943.21 500.385 1943.57 500.813C1943.93 501.241 1944.58 501.273 1945.01 500.911C1945.41 500.529 1945.47 499.901 1945.1 499.473Z",
    fill: "url(#paint109_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2206.48 793.617C2207.05 793.652 2207.46 794.139 2207.42 794.706C2207.38 795.273 2206.9 795.678 2206.33 795.643C2205.76 795.608 2205.36 795.121 2205.39 794.554C2205.45 793.986 2205.94 793.561 2206.48 793.617Z",
    fill: "url(#paint110_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136.52 770.834L2150.85 771.789L2150.91 771.121L2136.85 770.173L2050.19 671.007L2053.4 623.316L2000.42 562.665L1981.97 561.428L1939.46 512.767L1938.93 513.215L1981.63 562.069L2000.08 563.325L2052.72 623.548L2049.5 671.24L2136.52 770.834Z",
    fill: "url(#paint111_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1939.98 512.36C1939.62 511.932 1938.97 511.9 1938.55 512.263C1938.12 512.625 1938.09 513.272 1938.45 513.701C1938.81 514.129 1939.46 514.16 1939.89 513.798C1940.31 513.415 1940.37 512.787 1939.98 512.36Z",
    fill: "url(#paint112_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2150.89 770.435C2151.46 770.47 2151.87 770.957 2151.83 771.523C2151.8 772.09 2151.31 772.496 2150.74 772.46C2150.18 772.425 2149.77 771.938 2149.81 771.371C2149.84 770.825 2150.33 770.399 2150.89 770.435Z",
    fill: "url(#paint113_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1987.67 633.677L1988.18 633.231L1948.56 587.873L1920.11 585.973L1884.73 545.454L1884.22 545.9L1919.79 586.613L1948.23 588.534L1987.67 633.677Z",
    fill: "url(#paint114_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1885.27 545.046C1884.91 544.618 1884.26 544.586 1883.83 544.948C1883.41 545.311 1883.37 545.958 1883.74 546.386C1884.1 546.814 1884.75 546.846 1885.17 546.484C1885.6 546.121 1885.63 545.474 1885.27 545.046Z",
    fill: "url(#paint115_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1988.66 632.744C1989.02 633.172 1988.99 633.8 1988.56 634.182C1988.14 634.545 1987.51 634.512 1987.13 634.085C1986.76 633.657 1986.8 633.03 1987.22 632.647C1987.65 632.285 1988.3 632.316 1988.66 632.744Z",
    fill: "url(#paint116_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2021.33 644.936L2021.83 644.489L1962.43 576.513L1927.66 574.167L1902.34 545.193L1901.84 545.639L1927.33 574.828L1962.1 577.174L2021.33 644.936Z",
    fill: "url(#paint117_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1902.89 544.784C1902.52 544.356 1901.88 544.325 1901.45 544.687C1901.02 545.049 1900.99 545.697 1901.35 546.125C1901.71 546.553 1902.36 546.585 1902.79 546.222C1903.22 545.86 1903.25 545.213 1902.89 544.784Z",
    fill: "url(#paint118_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2022.3 644.004C2022.66 644.432 2022.63 645.06 2022.2 645.442C2021.77 645.804 2021.14 645.772 2020.76 645.345C2020.4 644.917 2020.43 644.289 2020.86 643.907C2021.29 643.544 2021.94 643.596 2022.3 644.004Z",
    fill: "url(#paint119_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2030.92 640.834L2031.59 640.885L2032.9 621.403L1993.64 576.494L1979.43 575.533L1932.98 522.384L1932.48 522.831L1979.09 576.194L1993.33 577.154L2032.2 621.656L2030.92 640.834Z",
    fill: "url(#paint120_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1933.53 521.976C1933.17 521.548 1932.52 521.517 1932.09 521.879C1931.66 522.241 1931.63 522.889 1931.99 523.317C1932.36 523.745 1933 523.777 1933.43 523.414C1933.86 523.052 1933.89 522.404 1933.53 521.976Z",
    fill: "url(#paint121_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2032.27 640.874C2032.24 641.441 2031.75 641.847 2031.18 641.811C2030.62 641.776 2030.21 641.289 2030.25 640.723C2030.28 640.156 2030.77 639.75 2031.34 639.786C2031.88 639.822 2032.31 640.308 2032.27 640.874Z",
    fill: "url(#paint122_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1952.02 565.368L1952.07 564.699L1939.47 563.848L1916.6 537.692L1916.1 538.138L1939.14 564.509L1952.02 565.368Z",
    fill: "url(#paint123_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1917.15 537.284C1916.79 536.856 1916.14 536.824 1915.71 537.187C1915.28 537.549 1915.25 538.196 1915.61 538.624C1915.98 539.052 1916.62 539.084 1917.05 538.722C1917.48 538.339 1917.51 537.712 1917.15 537.284Z",
    fill: "url(#paint124_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1952.06 564.034C1952.63 564.069 1953.03 564.556 1953 565.123C1952.96 565.689 1952.48 566.095 1951.91 566.059C1951.34 566.024 1950.94 565.537 1950.97 564.971C1951.01 564.404 1951.49 563.978 1952.06 564.034Z",
    fill: "url(#paint125_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2080.6 800.443L2081.29 800.493L2083.26 771.291L1999.75 675.72L1968.64 673.634L1925.51 624.275L1925.01 624.721L1968.31 674.275L1999.41 676.381L2082.56 771.524L2080.6 800.443Z",
    fill: "url(#paint126_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1926.06 623.867C1925.7 623.439 1925.05 623.407 1924.62 623.769C1924.19 624.132 1924.16 624.779 1924.52 625.207C1924.89 625.635 1925.53 625.667 1925.96 625.305C1926.37 624.923 1926.42 624.295 1926.06 623.867Z",
    fill: "url(#paint127_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2081.95 800.484C2081.92 801.051 2081.43 801.456 2080.86 801.421C2080.3 801.386 2079.89 800.899 2079.93 800.332C2079.96 799.765 2080.45 799.36 2081.02 799.395C2081.58 799.45 2081.99 799.937 2081.95 800.484Z",
    fill: "url(#paint128_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2067.55 775.384L2068.05 774.937L1992.41 688.363L1991.89 688.81L2067.55 775.384Z",
    fill: "url(#paint129_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1992.94 687.956C1992.58 687.528 1991.93 687.496 1991.5 687.858C1991.08 688.221 1991.04 688.868 1991.41 689.296C1991.77 689.724 1992.42 689.756 1992.84 689.394C1993.27 689.031 1993.32 688.383 1992.94 687.956Z",
    fill: "url(#paint130_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2068.54 774.451C2068.9 774.879 2068.87 775.506 2068.44 775.889C2068.01 776.251 2067.38 776.219 2067 775.791C2066.64 775.363 2066.67 774.736 2067.1 774.354C2067.53 773.991 2068.15 774.044 2068.54 774.451Z",
    fill: "url(#paint131_linear_5134_758)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.908 446.601L313.969 447.267L286.497 450.353L169.993 357.368L166.403 325.499L102.564 274.549L103.391 264.766L68.1333 236.629L68.5367 236.104L104.097 264.464L103.27 274.246L167.048 325.156L170.618 357.025L286.698 449.647L313.908 446.601Z",
    fill: "url(#paint132_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7502 237.193C67.3064 236.85 67.2459 236.205 67.5888 235.761C67.9317 235.317 68.5772 235.257 69.0209 235.6C69.4647 235.942 69.5252 236.588 69.1823 237.032C68.8192 237.455 68.1738 237.536 67.7502 237.193Z",
    fill: "url(#paint133_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter42_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.009 447.953C314.574 447.892 314.957 447.388 314.896 446.823C314.836 446.259 314.332 445.875 313.767 445.936C313.202 445.996 312.819 446.501 312.879 447.066C312.94 447.61 313.444 448.014 314.009 447.953Z",
    fill: "url(#paint134_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.414 492.65L258.117 516.814L257.452 516.894L254.769 492.992L165.919 422.094L119.87 427.258L39.5521 363.156L36.6274 337.177L6.83594 313.417L7.25951 312.892L37.2729 336.834L40.1774 362.793L120.072 426.552L166.121 421.388L255.414 492.65Z",
    fill: "url(#paint135_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.45282 313.981C6.00907 313.638 5.94856 312.993 6.29146 312.549C6.63435 312.105 7.2798 312.045 7.72355 312.388C8.16729 312.731 8.2278 313.376 7.88491 313.82C7.54202 314.243 6.89657 314.324 6.45282 313.981Z",
    fill: "url(#paint136_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.786 516.914C256.847 517.478 257.351 517.862 257.916 517.801C258.48 517.741 258.864 517.236 258.803 516.672C258.743 516.107 258.238 515.724 257.674 515.784C257.109 515.865 256.705 516.349 256.786 516.914Z",
    fill: "url(#paint137_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.516 481.234L338.577 481.899L326.313 483.271L304.106 465.561L287.384 467.437L157.367 363.681L153.877 332.579L95.6659 286.127L93.8102 269.607L54.3975 238.142L54.821 237.617L94.4355 269.244L96.2911 285.764L154.523 332.236L158.012 363.318L287.586 466.731L304.307 464.856L326.515 482.585L338.516 481.234Z",
    fill: "url(#paint138_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0143 238.706C53.5706 238.363 53.5101 237.718 53.853 237.274C54.1959 236.83 54.8413 236.77 55.2851 237.113C55.7288 237.456 55.7893 238.101 55.4464 238.545C55.0834 238.989 54.4379 239.049 54.0143 238.706Z",
    fill: "url(#paint139_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.617 482.585C339.182 482.524 339.565 482.02 339.504 481.455C339.444 480.89 338.939 480.507 338.375 480.568C337.81 480.628 337.427 481.133 337.487 481.697C337.548 482.242 338.052 482.645 338.617 482.585Z",
    fill: "url(#paint140_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.638 534.341L307.212 548.441L306.546 548.521L304.993 534.684L267.012 504.389L264.612 482.948L171.809 408.882L121.827 414.49L49.3952 356.682L47.1765 336.996L0.764648 299.963L1.18822 299.438L47.8219 336.653L50.0205 356.319L122.028 413.784L172.01 408.176L265.257 482.585L267.658 504.046L305.638 534.341Z",
    fill: "url(#paint141_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.381531 300.528C-0.0622149 300.185 -0.122726 299.54 0.220169 299.096C0.563064 298.652 1.20851 298.592 1.65226 298.935C2.096 299.277 2.15652 299.923 1.81362 300.367C1.45056 300.79 0.825277 300.871 0.381531 300.528Z",
    fill: "url(#paint142_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter45_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.861 548.541C305.921 549.106 306.425 549.489 306.99 549.429C307.555 549.368 307.938 548.864 307.878 548.299C307.817 547.734 307.313 547.351 306.748 547.412C306.203 547.492 305.8 547.996 305.861 548.541Z",
    fill: "url(#paint143_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M280.002 479.66L281.596 493.941L280.93 494.022L279.357 480.023L176.408 397.87L128.927 403.195L65.9754 352.971L63.918 334.596L13.4116 294.295L13.8352 293.771L64.5433 334.233L66.6006 352.608L129.128 402.509L176.609 397.164L280.002 479.66Z",
    fill: "url(#paint144_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0285 294.84C12.5848 294.497 12.5242 293.852 12.8671 293.408C13.21 292.964 13.8555 292.904 14.2992 293.247C14.743 293.589 14.8035 294.235 14.4606 294.679C14.0975 295.122 13.4521 295.203 13.0285 294.84Z",
    fill: "url(#paint145_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.244 494.042C280.305 494.607 280.809 494.99 281.374 494.93C281.939 494.869 282.322 494.365 282.261 493.8C282.201 493.235 281.697 492.852 281.132 492.913C280.587 492.973 280.184 493.477 280.244 494.042Z",
    fill: "url(#paint146_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.349 337.076L135.926 337.601L88.8482 300.044L85.6815 271.704L43.6265 238.161L44.05 237.637L86.3068 271.361L89.4937 299.68L136.349 337.076Z",
    fill: "url(#paint147_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2433 238.726C42.7996 238.383 42.7391 237.737 43.082 237.294C43.4249 236.85 44.0703 236.789 44.5141 237.132C44.9578 237.475 45.0183 238.121 44.6754 238.564C44.3325 239.008 43.6871 239.069 43.2433 238.726Z",
    fill: "url(#paint148_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.462 338.105C135.905 338.448 136.531 338.387 136.894 337.943C137.237 337.5 137.176 336.874 136.732 336.511C136.289 336.168 135.663 336.229 135.3 336.673C134.957 337.116 135.018 337.762 135.462 338.105Z",
    fill: "url(#paint149_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.097 370.197L148.673 370.721L78.1176 314.406L74.2248 279.774L44.1509 255.771L44.5745 255.247L74.8702 279.411L78.7631 314.043L149.097 370.197Z",
    fill: "url(#paint150_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7678 256.335C43.324 255.992 43.2635 255.347 43.6064 254.903C43.9493 254.459 44.5947 254.399 45.0385 254.742C45.4822 255.085 45.5427 255.73 45.1998 256.174C44.857 256.617 44.2115 256.678 43.7678 256.335Z",
    fill: "url(#paint151_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.21 371.205C148.653 371.548 149.279 371.488 149.642 371.044C149.985 370.6 149.924 369.975 149.48 369.612C149.037 369.269 148.411 369.329 148.048 369.773C147.705 370.217 147.786 370.862 148.21 371.205Z",
    fill: "url(#paint152_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.426 379.959L145.486 380.624L126.103 382.803L79.4891 345.589L77.8957 331.429L22.73 287.397L23.1536 286.873L78.5411 331.086L80.1346 345.246L126.304 382.097L145.426 379.959Z",
    fill: "url(#paint153_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3469 287.962C21.9031 287.619 21.8426 286.973 22.1855 286.529C22.5284 286.086 23.1738 286.025 23.6176 286.368C24.0613 286.711 24.1218 287.356 23.779 287.8C23.4361 288.244 22.7906 288.304 22.3469 287.962Z",
    fill: "url(#paint154_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.527 381.31C146.092 381.249 146.475 380.745 146.414 380.18C146.354 379.616 145.85 379.232 145.285 379.293C144.72 379.353 144.337 379.858 144.397 380.422C144.458 380.967 144.962 381.37 145.527 381.31Z",
    fill: "url(#paint155_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5197 304.502L65.8541 304.583L64.4422 292.037L37.293 270.354L37.7165 269.83L65.0876 291.674L66.5197 304.502Z",
    fill: "url(#paint156_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9099 270.918C36.4661 270.575 36.4056 269.93 36.7485 269.486C37.0914 269.042 37.7368 268.982 38.1806 269.325C38.6243 269.668 38.6848 270.313 38.3419 270.757C37.9789 271.2 37.3536 271.261 36.9099 270.918Z",
    fill: "url(#paint157_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1681 304.603C65.2286 305.167 65.7329 305.551 66.2977 305.49C66.8624 305.43 67.2457 304.925 67.1851 304.361C67.1246 303.796 66.6204 303.413 66.0556 303.473C65.511 303.534 65.1076 304.038 65.1681 304.603Z",
    fill: "url(#paint158_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.091 422.498L307.171 423.164L278.086 426.432L178.888 347.263L175.419 316.282L124.187 275.396L124.61 274.872L176.044 315.919L179.534 346.9L278.287 425.726L307.091 422.498Z",
    fill: "url(#paint159_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.803 275.961C123.36 275.618 123.299 274.973 123.642 274.529C123.985 274.085 124.63 274.025 125.074 274.368C125.518 274.711 125.578 275.356 125.235 275.8C124.872 276.223 124.227 276.304 123.803 275.961Z",
    fill: "url(#paint160_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter47_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.191 423.829C307.756 423.768 308.139 423.264 308.079 422.699C308.018 422.135 307.514 421.751 306.949 421.812C306.385 421.872 306.001 422.377 306.062 422.941C306.143 423.506 306.647 423.889 307.191 423.829Z",
    fill: "url(#paint161_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M281.475 410.558L281.051 411.082L191.192 339.377L191.616 338.832L281.475 410.558Z",
    fill: "url(#paint162_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.809 339.921C190.366 339.578 190.305 338.932 190.648 338.488C190.991 338.045 191.636 337.984 192.08 338.327C192.524 338.67 192.584 339.315 192.241 339.759C191.878 340.203 191.253 340.284 190.809 339.921Z",
    fill: "url(#paint163_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.587 411.585C281.031 411.928 281.656 411.868 282.019 411.424C282.362 410.98 282.302 410.355 281.858 409.992C281.414 409.649 280.789 409.709 280.426 410.153C280.083 410.597 280.164 411.222 280.587 411.585Z",
    fill: "url(#paint164_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.092 226.099L101.031 225.434L128.503 222.348L245.007 315.333L248.597 347.202L312.436 398.152L311.609 407.934L346.867 436.072L346.443 436.596L310.903 408.237L311.73 398.454L247.952 347.545L244.381 315.676L128.301 223.054L101.092 226.099Z",
    fill: "url(#paint165_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter49_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.25 435.506C347.694 435.849 347.754 436.495 347.411 436.938C347.068 437.382 346.423 437.443 345.979 437.1C345.535 436.757 345.475 436.111 345.818 435.668C346.181 435.244 346.826 435.163 347.25 435.506Z",
    fill: "url(#paint166_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.991 224.748C100.426 224.809 100.043 225.313 100.103 225.878C100.164 226.443 100.668 226.826 101.233 226.765C101.798 226.705 102.181 226.2 102.12 225.636C102.06 225.091 101.556 224.688 100.991 224.748Z",
    fill: "url(#paint167_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.586 180.051L156.883 155.887L157.548 155.807L160.231 179.708L249.081 250.627L295.13 245.443L375.448 309.544L378.373 335.524L408.144 359.284L407.741 359.809L377.727 335.867L374.823 309.908L294.928 246.149L248.879 251.313L159.586 180.051Z",
    fill: "url(#paint168_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.527 358.72C408.97 359.063 409.031 359.708 408.688 360.152C408.345 360.596 407.7 360.656 407.256 360.313C406.812 359.97 406.752 359.325 407.095 358.881C407.458 358.458 408.103 358.377 408.527 358.72Z",
    fill: "url(#paint169_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.214 155.786C158.153 155.222 157.649 154.838 157.084 154.899C156.519 154.959 156.136 155.464 156.197 156.028C156.257 156.593 156.761 156.976 157.326 156.916C157.891 156.835 158.294 156.351 158.214 155.786Z",
    fill: "url(#paint170_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4838 191.467L76.4233 190.802L88.6869 189.43L110.894 207.14L127.616 205.264L257.633 309.02L261.123 340.122L319.334 386.574L321.19 403.094L360.602 434.56L360.179 435.084L320.564 403.457L318.709 386.938L260.477 340.465L256.988 309.383L127.414 205.97L110.693 207.846L88.4852 190.116L76.4838 191.467Z",
    fill: "url(#paint171_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter51_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.986 433.994C361.43 434.337 361.49 434.982 361.147 435.426C360.804 435.87 360.159 435.93 359.715 435.588C359.271 435.245 359.211 434.599 359.554 434.155C359.917 433.712 360.542 433.651 360.986 433.994Z",
    fill: "url(#paint172_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.383 190.116C75.8183 190.176 75.435 190.681 75.4955 191.245C75.556 191.81 76.0603 192.193 76.6251 192.133C77.1898 192.072 77.5731 191.568 77.5126 191.003C77.452 190.459 76.9478 190.055 76.383 190.116Z",
    fill: "url(#paint173_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.361 138.358L107.788 124.259L108.454 124.179L110.007 138.016L147.987 168.311L150.388 189.752L243.191 263.818L293.173 258.21L365.605 316.018L367.823 335.704L414.235 372.737L413.812 373.261L367.178 336.047L364.979 316.381L292.971 258.916L242.989 264.523L149.742 190.115L147.342 168.674L109.361 138.358Z",
    fill: "url(#paint174_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.619 372.172C415.062 372.515 415.123 373.161 414.78 373.604C414.437 374.048 413.792 374.109 413.348 373.766C412.904 373.423 412.844 372.777 413.186 372.334C413.55 371.91 414.175 371.829 414.619 372.172Z",
    fill: "url(#paint175_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.119 124.159C109.059 123.594 108.555 123.211 107.99 123.271C107.425 123.332 107.042 123.836 107.102 124.401C107.163 124.966 107.667 125.349 108.232 125.288C108.797 125.208 109.2 124.704 109.119 124.159Z",
    fill: "url(#paint176_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.998 193.04L133.404 178.76L134.07 178.679L135.643 192.677L238.572 274.831L286.073 269.506L349.025 319.73L351.082 338.105L401.588 378.405L401.165 378.95L350.457 338.468L348.379 320.093L285.871 270.192L238.37 275.537L134.998 193.04Z",
    fill: "url(#paint177_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter53_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.972 377.861C402.415 378.204 402.476 378.849 402.133 379.293C401.79 379.737 401.145 379.797 400.701 379.454C400.257 379.112 400.197 378.466 400.54 378.022C400.903 377.579 401.528 377.498 401.972 377.861Z",
    fill: "url(#paint178_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.756 178.659C134.695 178.094 134.191 177.711 133.626 177.771C133.061 177.832 132.678 178.336 132.739 178.901C132.799 179.466 133.303 179.849 133.868 179.788C134.413 179.728 134.816 179.224 134.756 178.659Z",
    fill: "url(#paint179_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.65 335.625L279.074 335.1L326.151 372.657L329.318 400.996L371.373 434.54L370.95 435.064L328.693 401.339L325.506 373.02L278.65 335.625Z",
    fill: "url(#paint180_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.757 433.975C372.2 434.317 372.261 434.963 371.918 435.407C371.575 435.85 370.93 435.911 370.486 435.568C370.042 435.225 369.982 434.58 370.325 434.136C370.668 433.692 371.313 433.632 371.757 433.975Z",
    fill: "url(#paint181_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter55_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.538 334.595C279.094 334.252 278.469 334.313 278.106 334.757C277.763 335.2 277.824 335.826 278.267 336.189C278.711 336.532 279.336 336.471 279.699 336.027C280.042 335.584 279.982 334.938 279.538 334.595Z",
    fill: "url(#paint182_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.903 302.504L266.326 301.98L336.882 358.295L340.775 392.928L370.849 416.93L370.425 417.455L340.129 393.291L336.237 358.658L265.903 302.504Z",
    fill: "url(#paint183_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.232 416.366C371.676 416.709 371.737 417.354 371.394 417.798C371.051 418.242 370.405 418.302 369.962 417.96C369.518 417.617 369.457 416.971 369.8 416.528C370.143 416.084 370.789 416.023 371.232 416.366Z",
    fill: "url(#paint184_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter57_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.79 301.496C266.347 301.153 265.721 301.214 265.358 301.657C265.015 302.101 265.076 302.726 265.52 303.09C265.963 303.432 266.589 303.372 266.952 302.928C267.295 302.484 267.214 301.839 266.79 301.496Z",
    fill: "url(#paint185_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.574 292.742L269.493 292.077L288.897 289.898L335.51 327.113L337.104 341.272L392.27 385.304L391.846 385.828L336.458 341.635L334.865 327.455L288.675 290.604L269.574 292.742Z",
    fill: "url(#paint186_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.653 384.739C393.096 385.082 393.157 385.727 392.814 386.171C392.471 386.615 391.826 386.675 391.382 386.332C390.938 385.989 390.878 385.344 391.221 384.9C391.564 384.456 392.209 384.396 392.653 384.739Z",
    fill: "url(#paint187_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter59_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.473 291.39C268.908 291.451 268.525 291.955 268.585 292.52C268.646 293.085 269.15 293.468 269.715 293.407C270.28 293.347 270.663 292.843 270.602 292.278C270.542 291.733 270.038 291.33 269.473 291.39Z",
    fill: "url(#paint188_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M348.48 368.199L349.146 368.118L350.558 380.664L377.707 402.347L377.284 402.872L349.913 381.027L348.48 368.199Z",
    fill: "url(#paint189_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter60_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.09 401.783C378.534 402.126 378.594 402.772 378.252 403.215C377.909 403.659 377.263 403.72 376.82 403.377C376.376 403.034 376.315 402.388 376.658 401.945C377.021 401.501 377.646 401.44 378.09 401.783Z",
    fill: "url(#paint190_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter61_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.811 368.098C349.751 367.533 349.247 367.15 348.682 367.21C348.117 367.271 347.734 367.775 347.794 368.34C347.855 368.905 348.359 369.288 348.924 369.227C349.489 369.167 349.892 368.663 349.811 368.098Z",
    fill: "url(#paint191_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.909 250.222L107.829 249.537L136.914 246.269L236.112 325.437L239.581 356.419L290.813 397.304L290.39 397.829L238.956 356.782L235.466 325.8L136.712 246.975L107.909 250.222Z",
    fill: "url(#paint192_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter62_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.197 396.74C291.64 397.083 291.701 397.728 291.358 398.172C291.015 398.616 290.37 398.676 289.926 398.333C289.482 397.99 289.422 397.345 289.765 396.901C290.128 396.478 290.753 396.397 291.197 396.74Z",
    fill: "url(#paint193_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.808 248.872C107.244 248.932 106.86 249.436 106.921 250.001C106.981 250.566 107.486 250.949 108.05 250.889C108.615 250.828 108.998 250.324 108.938 249.759C108.857 249.194 108.353 248.811 107.808 248.872Z",
    fill: "url(#paint194_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.525 262.144L133.949 261.62L223.808 333.325L223.384 333.87L133.525 262.144Z",
    fill: "url(#paint195_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.191 332.78C224.635 333.123 224.695 333.769 224.352 334.212C224.009 334.656 223.364 334.717 222.92 334.374C222.476 334.031 222.416 333.386 222.759 332.942C223.102 332.498 223.747 332.417 224.191 332.78Z",
    fill: "url(#paint196_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.413 261.115C133.969 260.772 133.344 260.832 132.981 261.276C132.638 261.72 132.699 262.345 133.142 262.708C133.586 263.051 134.211 262.991 134.574 262.547C134.917 262.103 134.837 261.478 134.413 261.115Z",
    fill: "url(#paint197_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.764 603.399L351.432 603.368L353.291 630.95L255.207 743.195L223.209 745.362L169.465 806.867L159.729 805.605L130.049 839.574L129.543 839.147L159.459 804.886L169.195 806.148L222.896 744.701L254.892 742.555L352.594 630.717L350.764 603.399Z",
    fill: "url(#paint198_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.595 839.981C130.233 840.409 129.586 840.441 129.158 840.079C128.73 839.716 128.698 839.069 129.06 838.641C129.423 838.213 130.07 838.181 130.498 838.544C130.905 838.925 130.957 839.574 130.595 839.981Z",
    fill: "url(#paint199_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter63_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.119 603.358C352.083 602.791 351.597 602.386 351.03 602.421C350.463 602.457 350.058 602.943 350.093 603.51C350.128 604.077 350.615 604.482 351.182 604.447C351.729 604.411 352.154 603.925 352.119 603.358Z",
    fill: "url(#paint200_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M394.161 663.887L418.421 662.263L418.472 662.932L394.474 664.547L319.687 750.149L322.794 796.382L255.178 873.764L229.094 875.529L204.029 904.232L203.524 903.785L228.78 874.869L254.843 873.124L322.098 796.149L318.991 749.916L394.161 663.887Z",
    fill: "url(#paint201_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.576 904.64C204.214 905.068 203.566 905.099 203.138 904.737C202.71 904.375 202.678 903.727 203.041 903.299C203.403 902.871 204.05 902.839 204.478 903.202C204.886 903.563 204.938 904.212 204.576 904.64Z",
    fill: "url(#paint202_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter64_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.461 663.597C419.028 663.562 419.434 663.075 419.398 662.509C419.363 661.942 418.876 661.536 418.309 661.572C417.742 661.607 417.337 662.094 417.372 662.661C417.428 663.228 417.894 663.653 418.461 663.597Z",
    fill: "url(#paint203_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.459 580.358L387.126 580.327L387.95 592.64L369.269 614.036L370.398 630.824L260.951 756.09L229.724 758.19L180.724 814.273L164.139 815.391L130.948 853.363L130.443 852.916L163.804 814.75L180.39 813.633L229.411 757.53L260.618 755.429L369.701 630.591L368.572 613.803L387.274 592.408L386.459 580.358Z",
    fill: "url(#paint204_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.495 853.771C131.133 854.199 130.485 854.231 130.057 853.868C129.629 853.506 129.597 852.859 129.96 852.43C130.322 852.002 130.969 851.971 131.397 852.333C131.825 852.716 131.856 853.363 131.495 853.771Z",
    fill: "url(#paint205_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter65_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.813 580.318C387.777 579.751 387.291 579.346 386.724 579.381C386.157 579.416 385.752 579.903 385.787 580.47C385.822 581.037 386.309 581.442 386.876 581.407C387.422 581.37 387.848 580.885 387.813 580.318Z",
    fill: "url(#paint206_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M438.049 615.57L452.204 614.626L452.255 615.295L438.363 616.23L406.405 652.823L384.878 654.265L306.751 743.676L310.126 793.859L249.148 863.642L229.382 864.982L190.318 909.697L189.813 909.251L229.068 864.322L248.813 863.001L309.429 793.626L306.055 743.443L384.544 653.604L406.091 652.163L438.049 615.57Z",
    fill: "url(#paint207_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.865 910.105C190.503 910.533 189.856 910.565 189.428 910.203C189 909.84 188.968 909.193 189.33 908.765C189.693 908.337 190.34 908.305 190.768 908.668C191.175 909.049 191.228 909.677 190.865 910.105Z",
    fill: "url(#paint208_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter66_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.244 615.981C452.811 615.946 453.216 615.459 453.181 614.892C453.145 614.325 452.659 613.92 452.092 613.955C451.525 613.991 451.12 614.477 451.155 615.044C451.211 615.592 451.697 616.017 452.244 615.981Z",
    fill: "url(#paint209_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.279 638.744L396.617 637.789L396.668 638.457L382.613 639.405L295.954 738.591L299.158 786.262L246.179 846.913L227.73 848.15L185.22 896.81L184.715 896.364L227.396 847.509L245.844 846.273L298.482 786.03L295.258 738.359L382.279 638.744Z",
    fill: "url(#paint210_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.747 897.218C185.384 897.646 184.737 897.677 184.309 897.315C183.881 896.953 183.849 896.305 184.212 895.877C184.574 895.449 185.221 895.418 185.649 895.78C186.077 896.162 186.128 896.811 185.747 897.218Z",
    fill: "url(#paint211_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter67_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.658 639.143C397.225 639.108 397.63 638.621 397.595 638.054C397.56 637.487 397.073 637.082 396.506 637.117C395.939 637.153 395.534 637.639 395.569 638.206C395.605 638.753 396.091 639.179 396.658 639.143Z",
    fill: "url(#paint212_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.436 775.901L233.941 776.347L194.324 821.704L165.872 823.605L130.488 864.124L129.983 863.677L165.557 822.965L193.99 821.043L233.436 775.901Z",
    fill: "url(#paint213_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.035 864.532C130.673 864.96 130.025 864.992 129.597 864.63C129.169 864.267 129.137 863.62 129.5 863.192C129.862 862.764 130.509 862.732 130.937 863.094C131.366 863.457 131.397 864.104 131.035 864.532Z",
    fill: "url(#paint214_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.425 776.833C234.787 776.405 234.754 775.778 234.327 775.396C233.899 775.033 233.272 775.066 232.889 775.493C232.527 775.921 232.56 776.548 232.987 776.931C233.415 777.293 234.062 777.261 234.425 776.833Z",
    fill: "url(#paint215_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.092 764.642L267.597 765.088L208.193 833.064L173.422 835.41L148.103 864.385L147.598 863.938L173.088 834.749L207.859 832.403L267.092 764.642Z",
    fill: "url(#paint216_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.65 864.793C148.287 865.221 147.64 865.253 147.212 864.89C146.784 864.528 146.752 863.88 147.114 863.452C147.477 863.024 148.124 862.993 148.552 863.355C148.98 863.717 149.012 864.365 148.65 864.793Z",
    fill: "url(#paint217_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.059 765.573C268.422 765.145 268.389 764.518 267.962 764.135C267.534 763.773 266.907 763.806 266.524 764.233C266.162 764.661 266.195 765.288 266.622 765.671C267.05 766.033 267.698 765.981 268.059 765.573Z",
    fill: "url(#paint218_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68 768.744L277.348 768.713L278.66 788.174L239.406 833.083L225.19 834.044L178.744 887.193L178.239 886.747L224.876 833.384L239.092 832.423L277.964 787.941L276.68 768.744Z",
    fill: "url(#paint219_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.29 887.602C178.928 888.03 178.28 888.061 177.852 887.699C177.424 887.337 177.393 886.689 177.755 886.261C178.117 885.833 178.765 885.801 179.193 886.164C179.621 886.526 179.653 887.173 179.29 887.602Z",
    fill: "url(#paint220_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.035 768.704C278 768.137 277.513 767.731 276.946 767.767C276.379 767.802 275.974 768.289 276.009 768.855C276.044 769.422 276.531 769.828 277.098 769.792C277.645 769.756 278.07 769.27 278.035 768.704Z",
    fill: "url(#paint221_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.783 844.21L197.834 844.879L185.237 845.73L162.366 871.886L161.861 871.44L184.903 845.069L197.783 844.21Z",
    fill: "url(#paint222_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.913 872.294C162.55 872.722 161.903 872.754 161.475 872.391C161.047 872.029 161.015 871.381 161.378 870.953C161.74 870.525 162.387 870.494 162.815 870.856C163.243 871.239 163.275 871.866 162.913 872.294Z",
    fill: "url(#paint223_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.823 845.565C198.39 845.529 198.795 845.043 198.76 844.476C198.725 843.909 198.238 843.504 197.671 843.539C197.104 843.574 196.699 844.061 196.734 844.628C196.77 845.174 197.256 845.6 197.823 845.565Z",
    fill: "url(#paint224_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.381 609.135L327.05 609.084L329.018 638.287L245.509 733.858L214.403 735.943L171.276 785.303L170.771 784.857L214.068 735.302L245.175 733.197L328.322 638.054L326.381 609.135Z",
    fill: "url(#paint225_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.822 785.711C171.46 786.139 170.813 786.171 170.385 785.809C169.957 785.446 169.925 784.799 170.287 784.371C170.65 783.943 171.297 783.911 171.725 784.274C172.132 784.655 172.184 785.303 171.822 785.711Z",
    fill: "url(#paint226_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter68_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.715 609.094C327.68 608.527 327.193 608.122 326.626 608.157C326.059 608.192 325.654 608.679 325.689 609.246C325.724 609.813 326.211 610.218 326.778 610.183C327.346 610.128 327.751 609.641 327.715 609.094Z",
    fill: "url(#paint227_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M313.311 634.194L313.816 634.64L238.178 721.215L237.653 720.767L313.311 634.194Z",
    fill: "url(#paint228_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.704 721.622C238.342 722.05 237.694 722.082 237.266 721.719C236.838 721.357 236.807 720.71 237.169 720.282C237.531 719.854 238.179 719.822 238.607 720.184C239.034 720.567 239.087 721.195 238.704 721.622Z",
    fill: "url(#paint229_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter69_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.298 635.126C314.661 634.698 314.628 634.071 314.201 633.688C313.773 633.326 313.145 633.359 312.763 633.786C312.401 634.214 312.433 634.841 312.86 635.224C313.288 635.586 313.917 635.533 314.298 635.126Z",
    fill: "url(#paint230_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.998 806.178L120.331 806.209L118.472 778.627L216.555 666.383L248.553 664.216L302.297 602.711L312.033 603.973L341.714 570.004L342.219 570.45L312.304 604.691L302.568 603.429L248.867 664.876L216.87 667.023L119.168 778.86L120.998 806.178Z",
    fill: "url(#paint231_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter70_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.166 569.596C341.528 569.168 342.176 569.136 342.604 569.498C343.032 569.861 343.063 570.508 342.701 570.936C342.339 571.364 341.691 571.396 341.263 571.034C340.856 570.652 340.804 570.004 341.166 569.596Z",
    fill: "url(#paint232_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.644 806.219C119.679 806.786 120.166 807.191 120.733 807.156C121.3 807.12 121.705 806.634 121.67 806.067C121.634 805.5 121.148 805.095 120.581 805.13C120.034 805.166 119.609 805.652 119.644 806.219Z",
    fill: "url(#paint233_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6023 745.691L53.3418 747.314L53.2909 746.646L77.2885 745.031L152.096 659.429L148.969 613.195L216.585 535.813L242.669 534.049L267.733 505.366L268.239 505.792L242.983 534.709L216.92 536.454L149.665 613.428L152.772 659.661L77.6023 745.691Z",
    fill: "url(#paint234_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter71_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.186 504.958C267.548 504.53 268.196 504.498 268.624 504.86C269.052 505.222 269.083 505.87 268.721 506.298C268.359 506.726 267.711 506.758 267.283 506.395C266.876 506.014 266.824 505.365 267.186 504.958Z",
    fill: "url(#paint235_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.3004 745.98C52.7335 746.015 52.3282 746.502 52.3635 747.069C52.3988 747.636 52.8854 748.041 53.4523 748.006C54.0192 747.97 54.4246 747.484 54.3893 746.917C54.3338 746.349 53.8682 745.925 53.3004 745.98Z",
    fill: "url(#paint236_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3045 829.219L84.6368 829.25L83.813 816.937L102.494 795.541L101.366 778.753L210.812 653.487L242.039 651.387L291.039 595.303L307.625 594.186L340.815 556.214L341.32 556.661L307.959 594.827L291.374 595.944L242.353 652.047L211.146 654.148L102.062 778.986L103.191 795.774L84.4892 817.169L85.3045 829.219Z",
    fill: "url(#paint237_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter72_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.267 555.806C340.63 555.378 341.277 555.346 341.705 555.709C342.133 556.071 342.165 556.718 341.802 557.146C341.44 557.574 340.793 557.606 340.365 557.244C339.937 556.861 339.905 556.234 340.267 555.806Z",
    fill: "url(#paint238_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.9501 829.259C83.9854 829.826 84.4721 830.231 85.039 830.196C85.6059 830.161 86.0112 829.674 85.9759 829.107C85.9407 828.54 85.454 828.135 84.8871 828.17C84.3403 828.207 83.9148 828.692 83.9501 829.259Z",
    fill: "url(#paint239_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7133 794.008L19.5581 794.951L19.5072 794.283L33.3995 793.348L65.3575 756.755L86.8841 755.312L165.011 665.901L161.636 615.719L222.614 545.935L242.38 544.596L281.444 499.88L281.949 500.327L242.694 545.256L222.949 546.576L162.333 615.952L165.707 666.134L87.2181 755.973L65.6914 757.416L33.7133 794.008Z",
    fill: "url(#paint240_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter73_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.896 499.472C281.258 499.044 281.906 499.012 282.334 499.375C282.762 499.737 282.794 500.385 282.431 500.813C282.069 501.241 281.422 501.272 280.994 500.91C280.587 500.528 280.534 499.9 280.896 499.472Z",
    fill: "url(#paint241_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.5167 793.617C18.9498 793.652 18.5445 794.139 18.5798 794.706C18.6151 795.272 19.1017 795.678 19.6687 795.642C20.2356 795.607 20.6409 795.121 20.6056 794.554C20.5502 793.986 20.0644 793.56 19.5167 793.617Z",
    fill: "url(#paint242_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4829 770.833L75.1455 771.789L75.0946 771.12L89.149 770.172L175.807 671.006L172.604 623.315L225.583 562.664L244.032 561.427L286.542 512.767L287.068 513.214L244.367 562.068L225.917 563.325L173.28 623.547L176.504 671.239L89.4829 770.833Z",
    fill: "url(#paint243_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter74_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.016 512.36C286.378 511.932 287.026 511.9 287.454 512.262C287.882 512.625 287.913 513.272 287.551 513.7C287.189 514.128 286.541 514.16 286.113 513.797C285.686 513.415 285.633 512.787 286.016 512.36Z",
    fill: "url(#paint244_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.1051 770.434C74.5382 770.469 74.1329 770.956 74.1682 771.523C74.2034 772.09 74.6901 772.495 75.257 772.46C75.8239 772.425 76.2293 771.938 76.194 771.371C76.1578 770.824 75.672 770.399 75.1051 770.434Z",
    fill: "url(#paint245_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.327 633.677L237.822 633.23L277.439 587.873L305.891 585.972L341.275 545.453L341.78 545.9L306.206 586.612L277.773 588.534L238.327 633.677Z",
    fill: "url(#paint246_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter75_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.728 545.045C341.09 544.617 341.738 544.586 342.166 544.948C342.594 545.31 342.626 545.958 342.263 546.386C341.901 546.814 341.254 546.845 340.826 546.483C340.398 546.121 340.366 545.473 340.728 545.045Z",
    fill: "url(#paint247_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter76_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.338 632.744C236.976 633.172 237.008 633.799 237.435 634.182C237.863 634.544 238.491 634.512 238.873 634.084C239.236 633.656 239.203 633.029 238.776 632.647C238.348 632.284 237.7 632.316 237.338 632.744Z",
    fill: "url(#paint248_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M204.671 644.935L204.166 644.489L263.57 576.513L298.341 574.167L323.66 545.192L324.165 545.639L298.675 574.828L263.904 577.174L204.671 644.935Z",
    fill: "url(#paint249_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter77_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.113 544.784C323.476 544.356 324.123 544.324 324.551 544.687C324.979 545.049 325.011 545.696 324.649 546.124C324.286 546.552 323.639 546.584 323.211 546.222C322.783 545.86 322.751 545.212 323.113 544.784Z",
    fill: "url(#paint250_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter78_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.704 644.004C203.341 644.432 203.374 645.059 203.801 645.442C204.229 645.804 204.856 645.771 205.239 645.344C205.601 644.916 205.569 644.289 205.142 643.906C204.714 643.544 204.065 643.596 203.704 644.004Z",
    fill: "url(#paint251_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.083 640.833L194.414 640.884L193.102 621.403L232.357 576.494L246.573 575.533L293.019 522.384L293.524 522.83L246.907 576.194L232.67 577.154L193.798 621.656L195.083 640.833Z",
    fill: "url(#paint252_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter79_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.472 521.976C292.834 521.548 293.482 521.516 293.91 521.879C294.338 522.241 294.369 522.888 294.007 523.316C293.645 523.744 292.997 523.776 292.569 523.414C292.141 523.051 292.109 522.404 292.472 521.976Z",
    fill: "url(#paint253_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter80_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.727 640.874C193.763 641.441 194.249 641.846 194.816 641.811C195.383 641.776 195.789 641.289 195.753 640.722C195.718 640.155 195.231 639.75 194.664 639.785C194.118 639.821 193.692 640.307 193.727 640.874Z",
    fill: "url(#paint254_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.98 565.367L273.929 564.699L286.525 563.847L309.397 537.691L309.902 538.138L286.859 564.508L273.98 565.367Z",
    fill: "url(#paint255_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter81_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.85 537.284C309.213 536.856 309.86 536.824 310.288 537.186C310.716 537.548 310.748 538.196 310.385 538.624C310.023 539.052 309.376 539.084 308.948 538.721C308.52 538.339 308.488 537.712 308.85 537.284Z",
    fill: "url(#paint256_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter82_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.939 564.033C273.372 564.068 272.966 564.555 273.002 565.122C273.037 565.689 273.524 566.094 274.091 566.059C274.657 566.024 275.063 565.537 275.027 564.97C274.992 564.403 274.506 563.978 273.939 564.033Z",
    fill: "url(#paint257_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.401 800.443L144.713 800.493L142.744 771.291L226.254 675.719L257.359 673.634L300.487 624.274L300.992 624.721L257.694 674.275L226.588 676.38L143.441 771.523L145.401 800.443Z",
    fill: "url(#paint258_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter83_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.941 623.866C300.303 623.438 300.95 623.407 301.378 623.769C301.806 624.131 301.838 624.779 301.476 625.207C301.114 625.635 300.466 625.666 300.038 625.304C299.631 624.923 299.578 624.294 299.941 623.866Z",
    fill: "url(#paint259_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.047 800.483C144.082 801.05 144.569 801.456 145.136 801.42C145.703 801.385 146.108 800.898 146.073 800.331C146.038 799.765 145.551 799.359 144.984 799.395C144.416 799.45 144.011 799.937 144.047 800.483Z",
    fill: "url(#paint260_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.453 775.383L157.948 774.937L233.586 688.362L234.111 688.81L158.453 775.383Z",
    fill: "url(#paint261_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.059 687.955C233.421 687.527 234.069 687.496 234.497 687.858C234.925 688.22 234.956 688.868 234.594 689.296C234.232 689.724 233.584 689.755 233.156 689.393C232.728 689.031 232.676 688.382 233.059 687.955Z",
    fill: "url(#paint262_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.464 774.451C157.102 774.879 157.134 775.506 157.561 775.888C157.989 776.251 158.617 776.218 158.999 775.791C159.362 775.363 159.329 774.736 158.902 774.353C158.474 773.991 157.846 774.044 157.464 774.451Z",
    fill: "url(#paint263_linear_5134_758)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1016.69 277.743L1015.6 276.973L982.805 321.44L1027.33 616.018L1078.9 654.08L1103.29 815.494L1121.05 823.839L1134.52 912.985L1135.83 912.811L1122.28 822.919L1104.52 814.575L1080.14 653.305L1028.54 615.278L984.229 321.796L1016.69 277.743Z",
    fill: "url(#paint264_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1133.16 913.085C1133.31 914.196 1134.37 914.945 1135.48 914.795C1136.59 914.645 1137.34 913.588 1137.19 912.478C1137.04 911.367 1135.98 910.617 1134.87 910.767C1133.78 910.972 1132.99 912.009 1133.16 913.085Z",
    fill: "url(#paint265_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter84_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1014.45 276.218C1015.12 275.301 1016.38 275.142 1017.3 275.811C1018.21 276.48 1018.37 277.736 1017.7 278.653C1017.03 279.57 1015.78 279.729 1014.86 279.06C1013.98 278.411 1013.78 277.135 1014.45 276.218Z",
    fill: "url(#paint266_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M878.533 332.972L839.409 304.146L838.604 305.217L877.295 333.747L911.222 558.388L856.266 632.933L886.954 836.013L928.999 867.037L940.354 942.348L941.685 942.139L930.237 866.263L888.207 835.294L857.689 633.289L912.645 558.744L878.533 332.972Z",
    fill: "url(#paint267_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.994 942.448C939.144 943.558 940.201 944.308 941.312 944.158C942.422 944.008 943.172 942.951 943.022 941.841C942.872 940.73 941.815 939.98 940.704 940.13C939.629 940.3 938.844 941.337 938.994 942.448Z",
    fill: "url(#paint268_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter85_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.905 306.351C836.988 305.681 836.829 304.426 837.498 303.509C838.167 302.591 839.423 302.432 840.34 303.101C841.257 303.77 841.416 305.026 840.747 305.943C840.043 306.84 838.802 307.055 837.905 306.351Z",
    fill: "url(#paint269_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M981.338 200.54L980.247 199.77L965.617 219.626L974.078 275.763L954.121 302.831L1003.78 631.564L1054.13 668.685L1076.36 815.864L1103.1 835.585L1118.18 935.248L1119.51 935.039L1104.35 834.865L1077.61 815.145L1055.37 667.911L1005.05 630.809L955.545 303.187L975.501 276.119L967.006 219.962L981.338 200.54Z",
    fill: "url(#paint270_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.82 935.348C1116.97 936.459 1118.02 937.209 1119.13 937.058C1120.24 936.908 1120.99 935.852 1120.84 934.741C1120.69 933.63 1119.64 932.88 1118.53 933.03C1117.4 933.215 1116.65 934.272 1116.82 935.348Z",
    fill: "url(#paint271_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter86_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M979.101 199.016C979.77 198.099 981.026 197.94 981.943 198.609C982.86 199.278 983.019 200.534 982.35 201.451C981.681 202.368 980.425 202.527 979.508 201.858C978.626 201.209 978.432 199.933 979.101 199.016Z",
    fill: "url(#paint272_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M856.559 204.376L833.727 187.563L832.922 188.635L855.32 205.151L869.804 301.166L904.517 326.748L939.975 561.396L880.321 642.306L907.997 825.446L939.855 848.96L957.573 966.302L958.904 966.093L941.093 848.185L909.25 824.727L881.744 642.662L941.398 561.753L905.791 325.993L871.042 300.392L856.559 204.376Z",
    fill: "url(#paint273_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.212 966.4C956.362 967.511 957.419 968.261 958.53 968.111C959.641 967.961 960.39 966.904 960.24 965.793C960.09 964.682 959.033 963.933 957.923 964.083C956.827 964.288 956.062 965.29 956.212 966.4Z",
    fill: "url(#paint274_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter87_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M832.202 189.802C831.285 189.133 831.126 187.877 831.795 186.96C832.464 186.043 833.72 185.883 834.637 186.552C835.554 187.222 835.713 188.477 835.044 189.394C834.36 190.256 833.084 190.451 832.202 189.802Z",
    fill: "url(#paint275_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M925.587 303.395L902.461 286.366L901.657 287.437L924.314 304.149L963.632 564.442L906.966 641.305L930.989 800.457L960.739 822.381L980.021 950.076L981.352 949.866L961.992 821.662L932.243 799.738L908.355 641.641L965.056 564.798L925.587 303.395Z",
    fill: "url(#paint276_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.696 950.195C978.846 951.305 979.903 952.055 981.014 951.905C982.124 951.755 982.874 950.698 982.724 949.588C982.574 948.477 981.517 947.727 980.407 947.877C979.276 948.062 978.491 949.099 978.696 950.195Z",
    fill: "url(#paint277_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter88_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.936 288.604C900.019 287.935 899.86 286.679 900.529 285.762C901.198 284.845 902.454 284.686 903.371 285.355C904.288 286.024 904.447 287.28 903.778 288.197C903.129 289.079 901.853 289.273 900.936 288.604Z",
    fill: "url(#paint278_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1028.83 694.531L1027.5 694.74L1045.46 813.758L1091.35 847.56L1107.38 953.873L1108.71 953.664L1092.56 846.82L1046.73 813.004L1028.83 694.531Z",
    fill: "url(#paint279_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1106.02 953.973C1106.17 955.083 1107.23 955.833 1108.34 955.683C1109.45 955.533 1110.2 954.476 1110.05 953.365C1109.9 952.255 1108.84 951.505 1107.73 951.655C1106.62 951.805 1105.87 952.862 1106.02 953.973Z",
    fill: "url(#paint280_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.16 695.039C1026.01 693.928 1026.74 692.906 1027.87 692.721C1028.98 692.571 1030 693.301 1030.19 694.432C1030.34 695.543 1029.61 696.564 1028.48 696.749C1027.37 696.899 1026.31 696.15 1026.16 695.039Z",
    fill: "url(#paint281_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.24 639.368L982.908 639.577L1009.88 817.979L1065.93 859.326L1077.42 935.368L1078.75 935.158L1067.2 858.572L1011.15 817.225L984.24 639.368Z",
    fill: "url(#paint282_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1076.06 935.467C1076.21 936.578 1077.27 937.328 1078.38 937.178C1079.49 937.028 1080.24 935.971 1080.09 934.86C1079.94 933.749 1078.88 933 1077.77 933.15C1076.66 933.3 1075.91 934.356 1076.06 935.467Z",
    fill: "url(#paint283_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.607 639.896C981.457 638.786 982.186 637.764 983.317 637.579C984.428 637.429 985.45 638.159 985.635 639.289C985.785 640.4 985.055 641.422 983.924 641.607C982.814 641.757 981.777 640.972 981.607 639.896Z",
    fill: "url(#paint284_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.674 635.966L962.583 635.196L939.441 666.571L957.273 784.443L980.189 801.351L1001.27 940.839L1002.61 940.63L981.428 800.576L958.511 783.668L940.865 666.927L963.674 635.966Z",
    fill: "url(#paint285_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.914 940.939C1000.06 942.05 1001.12 942.799 1002.23 942.649C1003.34 942.499 1004.09 941.442 1003.94 940.332C1003.79 939.221 1002.74 938.471 1001.62 938.621C1000.51 938.771 999.764 939.828 999.914 940.939Z",
    fill: "url(#paint286_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.436 634.441C962.105 633.524 963.361 633.365 964.278 634.034C965.195 634.703 965.354 635.959 964.685 636.876C964.016 637.793 962.76 637.952 961.843 637.283C960.961 636.634 960.767 635.358 961.436 634.441Z",
    fill: "url(#paint287_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1015.43 847.95L1014.62 849.022L1034.93 864.003L1045.33 932.664L1046.66 932.455L1036.2 863.249L1015.43 847.95Z",
    fill: "url(#paint288_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.97 932.764C1044.12 933.875 1045.17 934.625 1046.29 934.474C1047.4 934.324 1048.15 933.268 1048 932.157C1047.85 931.046 1046.79 930.296 1045.68 930.446C1044.55 930.631 1043.82 931.653 1043.97 932.764Z",
    fill: "url(#paint289_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.9 850.19C1012.99 849.52 1012.83 848.265 1013.5 847.348C1014.16 846.43 1015.42 846.271 1016.34 846.94C1017.25 847.609 1017.41 848.865 1016.74 849.782C1016.1 850.664 1014.82 850.859 1013.9 850.19Z",
    fill: "url(#paint290_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.6 313.63L1050.53 312.825L1015.81 359.904L1053.71 610.719L1103.86 647.685L1123.43 777.221L1124.77 777.012L1105.12 646.966L1054.98 609.965L1017.23 360.26L1051.6 313.63Z",
    fill: "url(#paint291_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.07 777.321C1122.22 778.432 1123.28 779.182 1124.39 779.032C1125.5 778.882 1126.25 777.825 1126.1 776.714C1125.95 775.603 1124.9 774.854 1123.79 775.004C1122.69 775.209 1121.9 776.245 1122.07 777.321Z",
    fill: "url(#paint292_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter89_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1049.4 312.127C1050.07 311.21 1051.32 311.05 1052.24 311.719C1053.16 312.389 1053.32 313.644 1052.65 314.562C1051.98 315.479 1050.72 315.638 1049.8 314.969C1048.91 314.265 1048.75 313.009 1049.4 312.127Z",
    fill: "url(#paint293_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1046.67 369.903L1045.34 370.112L1079.65 597.305L1081.02 597.116L1046.67 369.903Z",
    fill: "url(#paint294_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.33 597.425C1078.48 598.535 1079.53 599.285 1080.65 599.135C1081.76 598.985 1082.51 597.928 1082.36 596.818C1082.21 595.707 1081.15 594.957 1080.04 595.107C1078.91 595.292 1078.14 596.294 1078.33 597.425Z",
    fill: "url(#paint295_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter90_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1044 370.412C1043.85 369.301 1044.58 368.279 1045.71 368.094C1046.82 367.944 1047.84 368.674 1048.03 369.805C1048.18 370.915 1047.45 371.937 1046.32 372.122C1045.21 372.272 1044.21 371.508 1044 370.412Z",
    fill: "url(#paint296_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1185.68 866.462L1186.78 867.231L1219.57 822.764L1175.05 528.187L1123.48 490.124L1099.08 328.71L1081.32 320.365L1067.85 231.219L1066.52 231.429L1080.09 321.285L1097.85 329.63L1122.24 490.899L1173.83 528.926L1218.15 822.408L1185.68 866.462Z",
    fill: "url(#paint297_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter91_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1069.22 231.122C1069.07 230.011 1068.01 229.261 1066.9 229.411C1065.79 229.561 1065.04 230.618 1065.19 231.729C1065.34 232.84 1066.39 233.589 1067.51 233.439C1068.6 233.234 1069.39 232.198 1069.22 231.122Z",
    fill: "url(#paint298_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1187.92 867.987C1187.25 868.904 1186 869.063 1185.08 868.394C1184.16 867.725 1184 866.469 1184.67 865.552C1185.34 864.635 1186.6 864.475 1187.51 865.145C1188.4 865.793 1188.59 867.069 1187.92 867.987Z",
    fill: "url(#paint299_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.84 811.232L1362.97 840.059L1363.77 838.987L1325.08 810.458L1291.12 585.797L1346.11 511.271L1315.42 308.191L1273.38 277.167L1262 201.891L1260.69 202.065L1272.14 277.941L1314.17 308.911L1344.69 510.915L1289.73 585.46L1323.84 811.232Z",
    fill: "url(#paint300_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter92_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1263.36 201.792C1263.21 200.681 1262.15 199.932 1261.04 200.082C1259.93 200.232 1259.18 201.288 1259.33 202.399C1259.48 203.51 1260.54 204.26 1261.65 204.11C1262.75 203.905 1263.53 202.868 1263.36 201.792Z",
    fill: "url(#paint301_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1364.47 837.855C1365.39 838.524 1365.55 839.78 1364.88 840.697C1364.21 841.614 1362.95 841.773 1362.04 841.104C1361.12 840.435 1360.96 839.179 1361.63 838.262C1362.33 837.365 1363.57 837.151 1364.47 837.855Z",
    fill: "url(#paint302_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.04 943.664L1222.13 944.434L1236.76 924.577L1228.3 868.441L1248.25 841.373L1198.59 512.64L1148.25 475.518L1126.01 328.339L1099.28 308.619L1084.2 208.955L1082.87 209.164L1098.02 309.338L1124.76 329.059L1147.01 476.293L1197.32 513.394L1246.83 841.017L1226.87 868.085L1235.37 924.241L1221.04 943.664Z",
    fill: "url(#paint303_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter93_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1085.56 208.858C1085.41 207.747 1084.35 206.997 1083.24 207.147C1082.13 207.297 1081.38 208.354 1081.53 209.465C1081.68 210.575 1082.74 211.325 1083.85 211.175C1084.98 210.99 1085.71 209.968 1085.56 208.858Z",
    fill: "url(#paint304_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1223.27 945.189C1222.61 946.106 1221.35 946.265 1220.43 945.596C1219.52 944.927 1219.36 943.671 1220.02 942.754C1220.69 941.837 1221.95 941.678 1222.87 942.347C1223.75 942.996 1223.94 944.272 1223.27 945.189Z",
    fill: "url(#paint305_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.82 939.83L1368.65 956.643L1369.45 955.572L1347.06 939.056L1332.57 843.04L1297.86 817.459L1262.4 582.81L1322.06 501.9L1294.38 318.76L1262.52 295.246L1244.8 177.905L1243.47 178.114L1261.28 296.021L1293.13 319.479L1320.63 501.544L1260.98 582.454L1296.59 818.213L1331.3 843.794L1345.82 939.83Z",
    fill: "url(#paint306_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter94_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1246.16 177.806C1246.01 176.695 1244.96 175.945 1243.85 176.095C1242.74 176.245 1241.99 177.302 1242.14 178.413C1242.29 179.524 1243.34 180.273 1244.45 180.123C1245.55 179.918 1246.31 178.917 1246.16 177.806Z",
    fill: "url(#paint307_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1370.15 954.439C1371.07 955.108 1371.23 956.364 1370.56 957.281C1369.89 958.198 1368.64 958.358 1367.72 957.689C1366.8 957.019 1366.64 955.764 1367.31 954.847C1368.02 953.95 1369.29 953.755 1370.15 954.439Z",
    fill: "url(#paint308_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.79 840.809L1299.91 857.838L1300.72 856.767L1278.06 840.055L1238.72 579.797L1295.41 502.899L1271.39 343.747L1241.64 321.823L1222.35 194.129L1220.99 194.318L1240.38 322.542L1270.11 344.501L1294.02 502.563L1237.3 579.441L1276.79 840.809Z",
    fill: "url(#paint309_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter95_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1223.68 194.01C1223.53 192.9 1222.47 192.15 1221.36 192.3C1220.25 192.45 1219.5 193.507 1219.65 194.617C1219.8 195.728 1220.86 196.478 1221.97 196.328C1223.1 196.143 1223.86 195.141 1223.68 194.01Z",
    fill: "url(#paint310_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1301.44 855.601C1302.36 856.27 1302.52 857.526 1301.85 858.443C1301.18 859.36 1299.92 859.519 1299 858.85C1298.09 858.181 1297.93 856.925 1298.6 856.008C1299.25 855.126 1300.52 854.932 1301.44 855.601Z",
    fill: "url(#paint311_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.55 449.674L1174.88 449.465L1156.92 330.447L1111.03 296.646L1095 190.332L1093.67 190.541L1109.81 297.385L1155.64 331.202L1173.55 449.674Z",
    fill: "url(#paint312_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter96_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1096.36 190.234C1096.21 189.123 1095.15 188.373 1094.04 188.523C1092.93 188.673 1092.18 189.73 1092.33 190.841C1092.48 191.951 1093.54 192.701 1094.65 192.551C1095.76 192.401 1096.51 191.344 1096.36 190.234Z",
    fill: "url(#paint313_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter97_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1176.22 449.167C1176.37 450.277 1175.64 451.299 1174.5 451.484C1173.39 451.634 1172.37 450.905 1172.19 449.774C1172.04 448.663 1172.77 447.641 1173.9 447.456C1175.01 447.306 1176.07 448.056 1176.22 449.167Z",
    fill: "url(#paint314_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1218.14 504.837L1219.47 504.628L1192.5 326.226L1136.44 284.879L1124.95 208.838L1123.62 209.047L1135.17 285.633L1191.23 326.981L1218.14 504.837Z",
    fill: "url(#paint315_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter98_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1126.31 208.737C1126.16 207.627 1125.1 206.877 1123.99 207.027C1122.88 207.177 1122.13 208.234 1122.28 209.345C1122.43 210.455 1123.49 211.205 1124.6 211.055C1125.71 210.905 1126.46 209.848 1126.31 208.737Z",
    fill: "url(#paint316_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter99_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1220.77 504.308C1220.92 505.419 1220.19 506.441 1219.06 506.626C1217.95 506.776 1216.92 506.046 1216.74 504.915C1216.59 503.805 1217.32 502.783 1218.45 502.598C1219.56 502.448 1220.6 503.232 1220.77 504.308Z",
    fill: "url(#paint317_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1238.7 508.238L1239.77 509.043L1262.93 477.634L1245.1 359.762L1222.19 342.853L1201.1 203.365L1199.77 203.574L1220.91 343.608L1243.86 360.536L1261.49 477.312L1238.7 508.238Z",
    fill: "url(#paint318_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter100_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1202.46 203.267C1202.31 202.156 1201.26 201.406 1200.14 201.556C1199.03 201.706 1198.28 202.763 1198.43 203.874C1198.58 204.985 1199.64 205.734 1200.75 205.584C1201.86 205.434 1202.61 204.378 1202.46 203.267Z",
    fill: "url(#paint319_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter101_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1240.94 509.763C1240.27 510.68 1239.02 510.84 1238.1 510.171C1237.18 509.502 1237.02 508.246 1237.69 507.329C1238.36 506.412 1239.62 506.252 1240.53 506.921C1241.42 507.57 1241.61 508.846 1240.94 509.763Z",
    fill: "url(#paint320_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1186.95 296.254L1187.75 295.183L1167.45 280.201L1157.05 211.541L1155.72 211.75L1166.17 280.956L1186.95 296.254Z",
    fill: "url(#paint321_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter102_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1158.41 211.441C1158.26 210.33 1157.2 209.58 1156.09 209.73C1154.98 209.88 1154.23 210.937 1154.38 212.048C1154.53 213.158 1155.59 213.908 1156.7 213.758C1157.83 213.573 1158.56 212.551 1158.41 211.441Z",
    fill: "url(#paint322_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter103_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1188.45 294.051C1189.37 294.72 1189.53 295.975 1188.86 296.893C1188.19 297.81 1186.93 297.969 1186.02 297.3C1185.1 296.631 1184.94 295.375 1185.61 294.458C1186.28 293.541 1187.56 293.346 1188.45 294.051Z",
    fill: "url(#paint323_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1150.74 830.554L1151.85 831.379L1186.57 784.3L1148.67 533.485L1098.51 496.519L1078.94 366.983L1077.61 367.192L1097.26 497.238L1147.4 534.239L1185.15 783.944L1150.74 830.554Z",
    fill: "url(#paint324_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter104_f_5134_758)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1080.3 366.883C1080.15 365.772 1079.09 365.022 1077.98 365.173C1076.87 365.323 1076.12 366.379 1076.27 367.49C1076.42 368.601 1077.48 369.351 1078.59 369.2C1079.69 368.995 1080.45 367.994 1080.3 366.883Z",
    fill: "url(#paint325_linear_5134_758)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1152.98 832.079C1152.31 832.996 1151.05 833.155 1150.14 832.486C1149.22 831.817 1149.06 830.561 1149.73 829.644C1150.4 828.727 1151.66 828.567 1152.57 829.237C1153.47 829.941 1153.63 831.196 1152.98 832.079Z",
    fill: "url(#paint326_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1155.71 774.301L1157.04 774.092L1122.72 546.899L1121.35 547.088L1155.71 774.301Z",
    fill: "url(#paint327_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.05 546.78C1123.9 545.67 1122.84 544.92 1121.73 545.07C1120.62 545.22 1119.87 546.277 1120.02 547.387C1120.17 548.498 1121.23 549.248 1122.34 549.098C1123.45 548.948 1124.23 547.911 1124.05 546.78Z",
    fill: "url(#paint328_linear_5134_758)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.37 773.794C1158.52 774.905 1157.79 775.927 1156.66 776.112C1155.55 776.262 1154.53 775.532 1154.35 774.401C1154.2 773.29 1154.93 772.269 1156.06 772.084C1157.17 771.934 1158.17 772.698 1158.37 773.794Z",
    fill: "url(#paint329_linear_5134_758)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5134_758",
    x: 1909.1,
    y: 443.93,
    width: 6.02979,
    height: 6.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5134_758",
    x: 1965.19,
    y: 513.778,
    width: 6.03369,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5134_758",
    x: 1884.49,
    y: 478.562,
    width: 6.02979,
    height: 6.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_5134_758",
    x: 1916.12,
    y: 545.405,
    width: 6.0293,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_5134_758",
    x: 1941.73,
    y: 490.906,
    width: 6.0293,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_5134_758",
    x: 1915.91,
    y: 419.806,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_5134_758",
    x: 1941.76,
    y: 407.771,
    width: 6.02734,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_5134_758",
    x: 1876.37,
    y: 433.292,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_5134_758",
    x: 1815.09,
    y: 356.506,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_5134_758",
    x: 1862.63,
    y: 431.774,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_5134_758",
    x: 1809,
    y: 369.958,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_5134_758",
    x: 1821.65,
    y: 375.632,
    width: 6.03369,
    height: 6.04248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_5134_758",
    x: 1851.86,
    y: 431.754,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_5134_758",
    x: 1944.08,
    y: 332.375,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_5134_758",
    x: 1852.39,
    y: 414.146,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_5134_758",
    x: 1956.83,
    y: 299.276,
    width: 6.02734,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_5134_758",
    x: 1830.97,
    y: 382.519,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_5134_758",
    x: 1953.39,
    y: 289.384,
    width: 6.02979,
    height: 6.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_5134_758",
    x: 1845.53,
    y: 399.563,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_f_5134_758",
    x: 1874.18,
    y: 365.204,
    width: 6.03369,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_5134_758",
    x: 1932.42,
    y: 394.526,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_5134_758",
    x: 1871.88,
    y: 600.42,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_f_5134_758",
    x: 1804.6,
    y: 659.57,
    width: 6.03027,
    height: 6.0332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_f_5134_758",
    x: 1836.19,
    y: 577.379,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_f_5134_758",
    x: 1770.82,
    y: 611.954,
    width: 6.03027,
    height: 6.03027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_f_5134_758",
    x: 1826.4,
    y: 635.116,
    width: 6.03027,
    height: 6.03027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_f_5134_758",
    x: 1896.28,
    y: 606.156,
    width: 6.03027,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_f_5134_758",
    x: 1909.45,
    y: 631.439,
    width: 6.03418,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_f_5134_758",
    x: 1881.05,
    y: 567.249,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_f_5134_758",
    x: 1955.03,
    y: 502.611,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_f_5134_758",
    x: 1881.95,
    y: 553.459,
    width: 6.03418,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_f_5134_758",
    x: 1941.32,
    y: 497.125,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_f_5134_758",
    x: 1936.2,
    y: 510.013,
    width: 6.04248,
    height: 6.03418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_f_5134_758",
    x: 1881.49,
    y: 542.699,
    width: 6.03467,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_f_5134_758",
    x: 1984.88,
    y: 630.397,
    width: 6.03369,
    height: 6.03418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_f_5134_758",
    x: 1899.1,
    y: 542.438,
    width: 6.03467,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_f_5134_758",
    x: 2018.51,
    y: 641.664,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_f_5134_758",
    x: 1929.74,
    y: 519.629,
    width: 6.03467,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_f_5134_758",
    x: 2028.24,
    y: 637.784,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_f_5134_758",
    x: 1913.36,
    y: 534.937,
    width: 6.03418,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_f_5134_758",
    x: 1948.97,
    y: 562.029,
    width: 6.03027,
    height: 6.03271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_f_5134_758",
    x: 1922.27,
    y: 621.52,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_f_5134_758",
    x: 310.873,
    y: 443.93,
    width: 6.02979,
    height: 6.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_f_5134_758",
    x: 254.776,
    y: 513.778,
    width: 6.03369,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_f_5134_758",
    x: 335.481,
    y: 478.562,
    width: 6.02979,
    height: 6.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_f_5134_758",
    x: 303.854,
    y: 545.405,
    width: 6.0293,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_f_5134_758",
    x: 278.238,
    y: 490.906,
    width: 6.0293,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_f_5134_758",
    x: 304.056,
    y: 419.806,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_f_5134_758",
    x: 278.212,
    y: 407.771,
    width: 6.02734,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_f_5134_758",
    x: 343.598,
    y: 433.292,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_f_5134_758",
    x: 404.875,
    y: 356.506,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_f_5134_758",
    x: 357.333,
    y: 431.774,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_f_5134_758",
    x: 410.966,
    y: 369.958,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_f_5134_758",
    x: 398.319,
    y: 375.632,
    width: 6.03369,
    height: 6.04248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_f_5134_758",
    x: 368.104,
    y: 431.754,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_f_5134_758",
    x: 275.886,
    y: 332.375,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_f_5134_758",
    x: 367.58,
    y: 414.146,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_f_5134_758",
    x: 263.138,
    y: 299.276,
    width: 6.02734,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_f_5134_758",
    x: 389,
    y: 382.519,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_f_5134_758",
    x: 266.579,
    y: 289.384,
    width: 6.02979,
    height: 6.0293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter60_f_5134_758",
    x: 374.438,
    y: 399.563,
    width: 6.03369,
    height: 6.03369,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter61_f_5134_758",
    x: 345.788,
    y: 365.204,
    width: 6.03369,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter62_f_5134_758",
    x: 287.544,
    y: 394.526,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter63_f_5134_758",
    x: 348.091,
    y: 600.419,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter64_f_5134_758",
    x: 415.37,
    y: 659.569,
    width: 6.03027,
    height: 6.0332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter65_f_5134_758",
    x: 383.785,
    y: 577.379,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter66_f_5134_758",
    x: 449.153,
    y: 611.953,
    width: 6.03027,
    height: 6.03027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter67_f_5134_758",
    x: 393.567,
    y: 635.115,
    width: 6.03027,
    height: 6.03027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter68_f_5134_758",
    x: 323.687,
    y: 606.155,
    width: 6.03027,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter69_f_5134_758",
    x: 310.514,
    y: 631.439,
    width: 6.03418,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter70_f_5134_758",
    x: 338.923,
    y: 567.249,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter71_f_5134_758",
    x: 264.943,
    y: 502.61,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter72_f_5134_758",
    x: 338.018,
    y: 553.459,
    width: 6.03418,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter73_f_5134_758",
    x: 278.654,
    y: 497.125,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter74_f_5134_758",
    x: 283.758,
    y: 510.013,
    width: 6.04248,
    height: 6.03418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter75_f_5134_758",
    x: 338.479,
    y: 542.698,
    width: 6.03467,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter76_f_5134_758",
    x: 235.089,
    y: 630.397,
    width: 6.03369,
    height: 6.03418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter77_f_5134_758",
    x: 320.864,
    y: 542.437,
    width: 6.03467,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter78_f_5134_758",
    x: 201.455,
    y: 641.664,
    width: 6.03369,
    height: 6.02734,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter79_f_5134_758",
    x: 290.222,
    y: 519.629,
    width: 6.03467,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter80_f_5134_758",
    x: 191.726,
    y: 637.783,
    width: 6.02979,
    height: 6.02979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter81_f_5134_758",
    x: 306.601,
    y: 534.937,
    width: 6.03418,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter82_f_5134_758",
    x: 271,
    y: 562.028,
    width: 6.03027,
    height: 6.03271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter83_f_5134_758",
    x: 297.698,
    y: 621.519,
    width: 6.02734,
    height: 6.03467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter84_f_5134_758",
    x: 1012.05,
    y: 273.401,
    width: 8.05957,
    height: 8.06934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter85_f_5134_758",
    x: 835.088,
    y: 300.691,
    width: 8.06934,
    height: 8.07861,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter86_f_5134_758",
    x: 976.701,
    y: 196.199,
    width: 8.05908,
    height: 8.06934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter87_f_5134_758",
    x: 829.385,
    y: 184.143,
    width: 8.06934,
    height: 8.04443,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter88_f_5134_758",
    x: 898.119,
    y: 282.945,
    width: 8.06934,
    height: 8.05908,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter89_f_5134_758",
    x: 1047,
    y: 309.31,
    width: 8.05518,
    height: 8.06934,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter90_f_5134_758",
    x: 1041.98,
    y: 366.075,
    width: 8.06689,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter91_f_5134_758",
    x: 1063.17,
    y: 227.392,
    width: 8.07031,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter92_f_5134_758",
    x: 1257.31,
    y: 198.062,
    width: 8.07031,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter93_f_5134_758",
    x: 1079.51,
    y: 205.128,
    width: 8.06641,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter94_f_5134_758",
    x: 1240.12,
    y: 174.076,
    width: 8.06592,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter95_f_5134_758",
    x: 1217.63,
    y: 190.281,
    width: 8.07471,
    height: 8.06592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter96_f_5134_758",
    x: 1090.31,
    y: 186.504,
    width: 8.06592,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter97_f_5134_758",
    x: 1170.17,
    y: 445.437,
    width: 8.06689,
    height: 8.06689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter98_f_5134_758",
    x: 1120.26,
    y: 205.008,
    width: 8.06592,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter99_f_5134_758",
    x: 1214.72,
    y: 500.58,
    width: 8.06689,
    height: 8.06592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter100_f_5134_758",
    x: 1196.42,
    y: 199.537,
    width: 8.06592,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter101_f_5134_758",
    x: 1235.28,
    y: 504.511,
    width: 8.05957,
    height: 8.06982,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter102_f_5134_758",
    x: 1152.36,
    y: 207.711,
    width: 8.06641,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter103_f_5134_758",
    x: 1183.2,
    y: 291.625,
    width: 8.06982,
    height: 8.08447,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter104_f_5134_758",
    x: 1074.25,
    y: 363.153,
    width: 8.06592,
    height: 8.06641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_5134_758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5134_758",
    x1: 1936.32,
    y1: 370.2,
    x2: 2049.01,
    y2: 262.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5134_758",
    x1: 2156.8,
    y1: 236.648,
    x2: 2157.85,
    y2: 235.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5134_758",
    x1: 1912.11,
    y1: 445.93,
    x2: 1912.11,
    y2: 447.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5134_758",
    x1: 1992.71,
    y1: 440.575,
    x2: 2100.09,
    y2: 330.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5134_758",
    x1: 2218.1,
    y1: 313.436,
    x2: 2219.15,
    y2: 312.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5134_758",
    x1: 1968.21,
    y1: 515.778,
    x2: 1968.21,
    y2: 517.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5134_758",
    x1: 1915.5,
    y1: 391.369,
    x2: 2044.75,
    y2: 266.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5134_758",
    x1: 2170.53,
    y1: 238.166,
    x2: 2171.59,
    y2: 237.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5134_758",
    x1: 1887.5,
    y1: 480.562,
    x2: 1887.5,
    y2: 482.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5134_758",
    x1: 1949.06,
    y1: 455.337,
    x2: 2080.17,
    y2: 321.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5134_758",
    x1: 2224.17,
    y1: 299.983,
    x2: 2225.22,
    y2: 299.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5134_758",
    x1: 1919.13,
    y1: 547.405,
    x2: 1919.13,
    y2: 549.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5134_758",
    x1: 1970.9,
    y1: 419.106,
    x2: 2075.71,
    y2: 302.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5134_758",
    x1: 2211.52,
    y1: 294.305,
    x2: 2212.58,
    y2: 293.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5134_758",
    x1: 1944.75,
    y1: 492.906,
    x2: 1944.75,
    y2: 494.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5134_758",
    x1: 2098.81,
    y1: 300.203,
    x2: 2149.74,
    y2: 260.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5134_758",
    x1: 2181.31,
    y1: 238.185,
    x2: 2182.36,
    y2: 237.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5134_758",
    x1: 2089.09,
    y1: 337.564,
    x2: 2090.14,
    y2: 336.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5134_758",
    x1: 2087.27,
    y1: 327.521,
    x2: 2145.78,
    y2: 283.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5134_758",
    x1: 2180.78,
    y1: 255.794,
    x2: 2181.83,
    y2: 254.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5134_758",
    x1: 2076.34,
    y1: 370.665,
    x2: 2077.39,
    y2: 369.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5134_758",
    x1: 2092.64,
    y1: 346.914,
    x2: 2143.05,
    y2: 293.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5134_758",
    x1: 2202.2,
    y1: 287.421,
    x2: 2203.25,
    y2: 286.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5134_758",
    x1: 2079.78,
    y1: 380.557,
    x2: 2080.83,
    y2: 379.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5134_758",
    x1: 2162.37,
    y1: 291.581,
    x2: 2179.56,
    y2: 279.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5134_758",
    x1: 2187.64,
    y1: 270.377,
    x2: 2188.69,
    y2: 269.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5134_758",
    x1: 2159.01,
    y1: 304.737,
    x2: 2160.06,
    y2: 303.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5134_758",
    x1: 1936.91,
    y1: 369.731,
    x2: 2016.71,
    y2: 289.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5134_758",
    x1: 2100.75,
    y1: 275.416,
    x2: 2101.8,
    y2: 274.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5134_758",
    x1: 1918.93,
    y1: 421.806,
    x2: 1918.93,
    y2: 423.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5134_758",
    x1: 1953.44,
    y1: 384.052,
    x2: 1991.46,
    y2: 344.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5134_758",
    x1: 2033.74,
    y1: 339.385,
    x2: 2034.8,
    y2: 338.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5134_758",
    x1: 1944.77,
    y1: 409.771,
    x2: 1944.77,
    y2: 411.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_5134_758",
    x1: 1903.42,
    y1: 356.443,
    x2: 2016.11,
    y2: 248.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_5134_758",
    x1: 1879.39,
    y1: 435.292,
    x2: 1879.39,
    y2: 437.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_5134_758",
    x1: 2124.07,
    y1: 226.012,
    x2: 2125.12,
    y2: 225.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_5134_758",
    x1: 1842.68,
    y1: 283.489,
    x2: 1950.06,
    y2: 173.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_5134_758",
    x1: 1818.11,
    y1: 358.506,
    x2: 1818.11,
    y2: 360.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_5134_758",
    x1: 2067.98,
    y1: 156.163,
    x2: 2069.03,
    y2: 155.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_5134_758",
    x1: 1893.47,
    y1: 343.182,
    x2: 2022.72,
    y2: 218.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_5134_758",
    x1: 1865.65,
    y1: 433.774,
    x2: 1865.65,
    y2: 435.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_5134_758",
    x1: 2148.68,
    y1: 191.38,
    x2: 2149.73,
    y2: 190.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_5134_758",
    x1: 1842.04,
    y1: 280.077,
    x2: 1973.15,
    y2: 145.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_5134_758",
    x1: 1812.02,
    y1: 371.958,
    x2: 1812.02,
    y2: 373.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_5134_758",
    x1: 2117.07,
    y1: 124.535,
    x2: 2118.12,
    y2: 123.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_5134_758",
    x1: 1850.91,
    y1: 304.026,
    x2: 1955.73,
    y2: 187.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_5134_758",
    x1: 1824.66,
    y1: 377.632,
    x2: 1824.66,
    y2: 379.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_5134_758",
    x1: 2091.44,
    y1: 179.035,
    x2: 2092.49,
    y2: 178.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_5134_758",
    x1: 1863.79,
    y1: 397.666,
    x2: 1914.71,
    y2: 358.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_5134_758",
    x1: 1854.88,
    y1: 433.754,
    x2: 1854.88,
    y2: 435.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_5134_758",
    x1: 1947.1,
    y1: 334.375,
    x2: 1947.1,
    y2: 336.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_5134_758",
    x1: 1865.52,
    y1: 374.254,
    x2: 1924.03,
    y2: 329.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_5134_758",
    x1: 1855.4,
    y1: 416.146,
    x2: 1855.4,
    y2: 418.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_5134_758",
    x1: 1959.85,
    y1: 301.276,
    x2: 1959.85,
    y2: 303.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_5134_758",
    x1: 1845.86,
    y1: 349.94,
    x2: 1896.27,
    y2: 296.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_5134_758",
    x1: 1833.98,
    y1: 384.519,
    x2: 1833.98,
    y2: 386.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_5134_758",
    x1: 1956.41,
    y1: 291.384,
    x2: 1956.41,
    y2: 293.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_5134_758",
    x1: 1851.18,
    y1: 389.87,
    x2: 1868.38,
    y2: 377.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_5134_758",
    x1: 1848.55,
    y1: 401.563,
    x2: 1848.55,
    y2: 403.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_5134_758",
    x1: 1877.2,
    y1: 367.204,
    x2: 1877.2,
    y2: 369.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_5134_758",
    x1: 1953.26,
    y1: 341.128,
    x2: 2033.06,
    y2: 260.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_5134_758",
    x1: 1935.44,
    y1: 396.526,
    x2: 1935.44,
    y2: 398.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_5134_758",
    x1: 2117.26,
    y1: 250.136,
    x2: 2118.31,
    y2: 249.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_5134_758",
    x1: 2011.11,
    y1: 306.84,
    x2: 2049.12,
    y2: 267.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_5134_758",
    x1: 2001.63,
    y1: 333.83,
    x2: 2002.69,
    y2: 332.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_5134_758",
    x1: 2091.41,
    y1: 262.167,
    x2: 2092.46,
    y2: 261.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_5134_758",
    x1: 1952.64,
    y1: 624.198,
    x2: 2065.22,
    y2: 731.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_5134_758",
    x1: 2095.88,
    y1: 838.508,
    x2: 2096.81,
    y2: 839.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_5134_758",
    x1: 1875.91,
    y1: 603.39,
    x2: 1873.88,
    y2: 603.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_5134_758",
    x1: 1884.85,
    y1: 683.667,
    x2: 1999.65,
    y2: 786.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_5134_758",
    x1: 2021.9,
    y1: 903.166,
    x2: 2022.83,
    y2: 904.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_5134_758",
    x1: 1808.63,
    y1: 662.542,
    x2: 1806.6,
    y2: 662.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_5134_758",
    x1: 1930.56,
    y1: 604.342,
    x2: 2060.7,
    y2: 727.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_5134_758",
    x1: 2094.98,
    y1: 852.297,
    x2: 2095.9,
    y2: 853.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_5134_758",
    x1: 1840.21,
    y1: 580.349,
    x2: 1838.19,
    y2: 580.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_5134_758",
    x1: 1868.16,
    y1: 640.724,
    x2: 2008.18,
    y2: 765.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_5134_758",
    x1: 2035.61,
    y1: 908.632,
    x2: 2036.54,
    y2: 909.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_5134_758",
    x1: 1774.85,
    y1: 614.923,
    x2: 1772.82,
    y2: 615.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_5134_758",
    x1: 1905.32,
    y1: 660.924,
    x2: 2026.76,
    y2: 760.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_5134_758",
    x1: 2040.72,
    y1: 895.744,
    x2: 2041.65,
    y2: 896.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_5134_758",
    x1: 1830.43,
    y1: 638.085,
    x2: 1828.4,
    y2: 638.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_5134_758",
    x1: 2029.81,
    y1: 783.41,
    x2: 2071.37,
    y2: 832.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_5134_758",
    x1: 2095.44,
    y1: 863.059,
    x2: 2096.36,
    y2: 864.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_5134_758",
    x1: 1992.05,
    y1: 775.36,
    x2: 1992.97,
    y2: 776.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_5134_758",
    x1: 2002,
    y1: 773.098,
    x2: 2048.85,
    y2: 829.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_5134_758",
    x1: 2077.83,
    y1: 863.319,
    x2: 2078.75,
    y2: 864.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_5134_758",
    x1: 1958.42,
    y1: 764.099,
    x2: 1959.34,
    y2: 765.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_5134_758",
    x1: 1982.87,
    y1: 779.327,
    x2: 2038.77,
    y2: 827.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_5134_758",
    x1: 2047.19,
    y1: 886.128,
    x2: 2048.11,
    y2: 887.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_5134_758",
    x1: 1948.69,
    y1: 767.978,
    x2: 1949.61,
    y2: 768.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_5134_758",
    x1: 2041.25,
    y1: 846.519,
    x2: 2054.05,
    y2: 863.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_5134_758",
    x1: 2063.56,
    y1: 870.82,
    x2: 2064.49,
    y2: 871.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_5134_758",
    x1: 2027.96,
    y1: 843.75,
    x2: 2028.88,
    y2: 844.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_5134_758",
    x1: 1953.13,
    y1: 624.764,
    x2: 2036.83,
    y2: 700.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_5134_758",
    x1: 2054.66,
    y1: 784.238,
    x2: 2055.58,
    y2: 785.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_5134_758",
    x1: 1900.31,
    y1: 609.125,
    x2: 1898.28,
    y2: 609.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_5134_758",
    x1: 1939.57,
    y1: 641.924,
    x2: 1980.77,
    y2: 678.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_5134_758",
    x1: 1987.77,
    y1: 720.149,
    x2: 1988.69,
    y2: 721.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_5134_758",
    x1: 1913.49,
    y1: 634.408,
    x2: 1911.45,
    y2: 634.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_5134_758",
    x1: 1964.92,
    y1: 590.719,
    x2: 2077.5,
    y2: 698.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_5134_758",
    x1: 1885.08,
    y1: 570.221,
    x2: 1883.05,
    y2: 570.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_5134_758",
    x1: 2105.05,
    y1: 805.341,
    x2: 2105.97,
    y2: 806.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_5134_758",
    x1: 2035.09,
    y1: 526.787,
    x2: 2149.89,
    y2: 629.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_5134_758",
    x1: 1959.06,
    y1: 505.583,
    x2: 1957.03,
    y2: 505.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_5134_758",
    x1: 2172.33,
    y1: 746.188,
    x2: 2173.26,
    y2: 747.199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_5134_758",
    x1: 1977.72,
    y1: 580.191,
    x2: 2107.86,
    y2: 703.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_5134_758",
    x1: 1885.98,
    y1: 556.431,
    x2: 1883.95,
    y2: 556.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_5134_758",
    x1: 2140.75,
    y1: 828.382,
    x2: 2141.67,
    y2: 829.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_5134_758",
    x1: 2038.47,
    y1: 525.998,
    x2: 2178.5,
    y2: 650.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_5134_758",
    x1: 1945.35,
    y1: 500.098,
    x2: 1943.32,
    y2: 500.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_5134_758",
    x1: 2206.12,
    y1: 793.824,
    x2: 2207.04,
    y2: 794.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_5134_758",
    x1: 2014.94,
    y1: 535.922,
    x2: 2136.38,
    y2: 635.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_5134_758",
    x1: 1940.24,
    y1: 512.985,
    x2: 1938.2,
    y2: 513.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_5134_758",
    x1: 2150.53,
    y1: 770.646,
    x2: 2151.45,
    y2: 771.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_5134_758",
    x1: 1921.97,
    y1: 552.962,
    x2: 1963.53,
    y2: 602.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_5134_758",
    x1: 1885.52,
    y1: 545.671,
    x2: 1883.49,
    y2: 545.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_5134_758",
    x1: 1988.91,
    y1: 633.369,
    x2: 1986.88,
    y2: 633.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_5134_758",
    x1: 1945.44,
    y1: 553.649,
    x2: 1992.28,
    y2: 610.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_5134_758",
    x1: 1903.14,
    y1: 545.409,
    x2: 1901.1,
    y2: 545.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_5134_758",
    x1: 2022.55,
    y1: 644.632,
    x2: 2020.51,
    y2: 644.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_5134_758",
    x1: 1968.85,
    y1: 532.926,
    x2: 2024.76,
    y2: 580.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_5134_758",
    x1: 1933.78,
    y1: 522.601,
    x2: 1931.74,
    y2: 522.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_5134_758",
    x1: 2032.27,
    y1: 640.753,
    x2: 2030.25,
    y2: 640.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_5134_758",
    x1: 1929.2,
    y1: 540.02,
    x2: 1941.99,
    y2: 556.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_5134_758",
    x1: 1917.4,
    y1: 537.909,
    x2: 1915.37,
    y2: 538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_5134_758",
    x1: 1953,
    y1: 564.999,
    x2: 1950.97,
    y2: 565.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_5134_758",
    x1: 1982.44,
    y1: 639.831,
    x2: 2066.14,
    y2: 715.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_5134_758",
    x1: 1926.3,
    y1: 624.492,
    x2: 1924.28,
    y2: 624.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_5134_758",
    x1: 2080.65,
    y1: 799.606,
    x2: 2081.57,
    y2: 800.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_5134_758",
    x1: 2019.27,
    y1: 696.093,
    x2: 2060.48,
    y2: 732.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_5134_758",
    x1: 1991.88,
    y1: 687.822,
    x2: 1992.81,
    y2: 688.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_5134_758",
    x1: 2067.48,
    y1: 774.323,
    x2: 2068.4,
    y2: 775.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_5134_758",
    x1: 289.681,
    y1: 370.2,
    x2: 176.992,
    y2: 262.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_5134_758",
    x1: 69.2015,
    y1: 236.648,
    x2: 68.1511,
    y2: 235.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_5134_758",
    x1: 313.888,
    y1: 445.93,
    x2: 313.888,
    y2: 447.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_5134_758",
    x1: 233.292,
    y1: 440.575,
    x2: 125.914,
    y2: 330.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_5134_758",
    x1: 7.90415,
    y1: 313.436,
    x2: 6.8537,
    y2: 312.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_5134_758",
    x1: 257.793,
    y1: 515.778,
    x2: 257.793,
    y2: 517.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_5134_758",
    x1: 310.501,
    y1: 391.369,
    x2: 181.249,
    y2: 266.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_5134_758",
    x1: 55.4657,
    y1: 238.166,
    x2: 54.4125,
    y2: 237.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_5134_758",
    x1: 338.496,
    y1: 480.562,
    x2: 338.496,
    y2: 482.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_5134_758",
    x1: 276.936,
    y1: 455.337,
    x2: 145.827,
    y2: 321.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_5134_758",
    x1: 1.83286,
    y1: 299.983,
    x2: 0.782409,
    y2: 299.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_5134_758",
    x1: 306.869,
    y1: 547.405,
    x2: 306.869,
    y2: 549.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_5134_758",
    x1: 255.1,
    y1: 419.106,
    x2: 150.287,
    y2: 302.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_5134_758",
    x1: 14.4798,
    y1: 294.305,
    x2: 13.4231,
    y2: 293.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_5134_758",
    x1: 281.253,
    y1: 492.906,
    x2: 281.253,
    y2: 494.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_5134_758",
    x1: 127.189,
    y1: 300.203,
    x2: 76.2639,
    y2: 260.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_5134_758",
    x1: 44.6947,
    y1: 238.185,
    x2: 43.6415,
    y2: 237.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_5134_758",
    x1: 136.913,
    y1: 337.564,
    x2: 135.86,
    y2: 336.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_5134_758",
    x1: 138.729,
    y1: 327.521,
    x2: 80.2162,
    y2: 283.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_5134_758",
    x1: 45.2191,
    y1: 255.794,
    x2: 44.166,
    y2: 254.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_5134_758",
    x1: 149.662,
    y1: 370.665,
    x2: 148.609,
    y2: 369.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_5134_758",
    x1: 133.359,
    y1: 346.914,
    x2: 82.9508,
    y2: 293.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_5134_758",
    x1: 23.7982,
    y1: 287.421,
    x2: 22.7451,
    y2: 286.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_5134_758",
    x1: 146.22,
    y1: 380.557,
    x2: 145.169,
    y2: 379.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_5134_758",
    x1: 63.6322,
    y1: 291.581,
    x2: 46.4369,
    y2: 279.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_5134_758",
    x1: 38.3612,
    y1: 270.377,
    x2: 37.3081,
    y2: 269.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_5134_758",
    x1: 66.9909,
    y1: 304.737,
    x2: 65.94,
    y2: 303.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_5134_758",
    x1: 289.093,
    y1: 369.731,
    x2: 209.295,
    y2: 289.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_5134_758",
    x1: 125.255,
    y1: 275.416,
    x2: 124.204,
    y2: 274.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_5134_758",
    x1: 307.07,
    y1: 421.806,
    x2: 307.07,
    y2: 423.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_5134_758",
    x1: 272.555,
    y1: 384.052,
    x2: 234.544,
    y2: 344.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_5134_758",
    x1: 192.261,
    y1: 339.385,
    x2: 191.204,
    y2: 338.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_5134_758",
    x1: 281.226,
    y1: 409.771,
    x2: 281.226,
    y2: 411.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_5134_758",
    x1: 322.579,
    y1: 356.443,
    x2: 209.89,
    y2: 248.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_5134_758",
    x1: 346.615,
    y1: 435.292,
    x2: 346.615,
    y2: 437.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_5134_758",
    x1: 101.926,
    y1: 226.012,
    x2: 100.875,
    y2: 225.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_5134_758",
    x1: 383.321,
    y1: 283.489,
    x2: 275.943,
    y2: 173.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_5134_758",
    x1: 407.891,
    y1: 358.506,
    x2: 407.891,
    y2: 360.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_5134_758",
    x1: 158.023,
    y1: 156.163,
    x2: 156.972,
    y2: 155.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_5134_758",
    x1: 332.527,
    y1: 343.182,
    x2: 203.275,
    y2: 218.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_5134_758",
    x1: 360.35,
    y1: 433.774,
    x2: 360.35,
    y2: 435.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_5134_758",
    x1: 77.3183,
    y1: 191.38,
    x2: 76.2675,
    y2: 190.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_5134_758",
    x1: 383.96,
    y1: 280.077,
    x2: 252.85,
    y2: 145.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_5134_758",
    x1: 413.983,
    y1: 371.958,
    x2: 413.983,
    y2: 373.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_5134_758",
    x1: 108.929,
    y1: 124.535,
    x2: 107.878,
    y2: 123.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_5134_758",
    x1: 375.093,
    y1: 304.026,
    x2: 270.268,
    y2: 187.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_5134_758",
    x1: 401.336,
    y1: 377.632,
    x2: 401.336,
    y2: 379.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_5134_758",
    x1: 134.561,
    y1: 179.035,
    x2: 133.51,
    y2: 178.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_5134_758",
    x1: 362.213,
    y1: 397.666,
    x2: 311.288,
    y2: 358.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_5134_758",
    x1: 371.121,
    y1: 433.754,
    x2: 371.121,
    y2: 435.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_5134_758",
    x1: 278.903,
    y1: 334.375,
    x2: 278.903,
    y2: 336.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_5134_758",
    x1: 360.481,
    y1: 374.254,
    x2: 301.968,
    y2: 329.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_5134_758",
    x1: 370.597,
    y1: 416.146,
    x2: 370.597,
    y2: 418.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_5134_758",
    x1: 266.152,
    y1: 301.276,
    x2: 266.152,
    y2: 303.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_5134_758",
    x1: 380.14,
    y1: 349.94,
    x2: 329.733,
    y2: 296.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_5134_758",
    x1: 392.017,
    y1: 384.519,
    x2: 392.017,
    y2: 386.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_5134_758",
    x1: 269.594,
    y1: 291.384,
    x2: 269.594,
    y2: 293.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_5134_758",
    x1: 374.82,
    y1: 389.87,
    x2: 357.624,
    y2: 377.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_5134_758",
    x1: 377.455,
    y1: 401.563,
    x2: 377.455,
    y2: 403.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_5134_758",
    x1: 348.805,
    y1: 367.204,
    x2: 348.805,
    y2: 369.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_5134_758",
    x1: 272.735,
    y1: 341.128,
    x2: 192.937,
    y2: 260.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_5134_758",
    x1: 290.561,
    y1: 396.526,
    x2: 290.561,
    y2: 398.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_5134_758",
    x1: 108.744,
    y1: 250.136,
    x2: 107.693,
    y2: 249.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_5134_758",
    x1: 214.888,
    y1: 306.84,
    x2: 176.877,
    y2: 267.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_5134_758",
    x1: 224.371,
    y1: 333.83,
    x2: 223.315,
    y2: 332.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_5134_758",
    x1: 134.588,
    y1: 262.167,
    x2: 133.535,
    y2: 261.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_5134_758",
    x1: 273.359,
    y1: 624.197,
    x2: 160.778,
    y2: 731.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_5134_758",
    x1: 130.116,
    y1: 838.507,
    x2: 129.193,
    y2: 839.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_5134_758",
    x1: 350.092,
    y1: 603.389,
    x2: 352.119,
    y2: 603.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_5134_758",
    x1: 341.152,
    y1: 683.667,
    x2: 226.345,
    y2: 786.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_5134_758",
    x1: 204.096,
    y1: 903.165,
    x2: 203.173,
    y2: 904.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_5134_758",
    x1: 417.371,
    y1: 662.541,
    x2: 419.399,
    y2: 662.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_5134_758",
    x1: 295.435,
    y1: 604.341,
    x2: 165.297,
    y2: 727.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_5134_758",
    x1: 131.019,
    y1: 852.297,
    x2: 130.096,
    y2: 853.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_5134_758",
    x1: 385.786,
    y1: 580.349,
    x2: 387.813,
    y2: 580.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_5134_758",
    x1: 357.843,
    y1: 640.723,
    x2: 217.822,
    y2: 765.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_5134_758",
    x1: 190.386,
    y1: 908.631,
    x2: 189.463,
    y2: 909.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_5134_758",
    x1: 451.154,
    y1: 614.923,
    x2: 453.182,
    y2: 615.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_5134_758",
    x1: 320.675,
    y1: 660.923,
    x2: 199.239,
    y2: 760.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_5134_758",
    x1: 185.277,
    y1: 895.744,
    x2: 184.354,
    y2: 896.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_5134_758",
    x1: 395.568,
    y1: 638.085,
    x2: 397.596,
    y2: 638.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_5134_758",
    x1: 196.191,
    y1: 783.409,
    x2: 154.63,
    y2: 832.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_5134_758",
    x1: 130.559,
    y1: 863.058,
    x2: 129.636,
    y2: 864.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_5134_758",
    x1: 233.949,
    y1: 775.359,
    x2: 233.026,
    y2: 776.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_5134_758",
    x1: 223.996,
    y1: 773.098,
    x2: 177.154,
    y2: 829.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_5134_758",
    x1: 148.174,
    y1: 863.319,
    x2: 147.251,
    y2: 864.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_5134_758",
    x1: 267.584,
    y1: 764.099,
    x2: 266.664,
    y2: 765.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_5134_758",
    x1: 243.131,
    y1: 779.327,
    x2: 187.228,
    y2: 827.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_5134_758",
    x1: 178.815,
    y1: 886.128,
    x2: 177.892,
    y2: 887.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_5134_758",
    x1: 277.313,
    y1: 767.977,
    x2: 276.392,
    y2: 768.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_5134_758",
    x1: 184.746,
    y1: 846.519,
    x2: 171.951,
    y2: 863.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_5134_758",
    x1: 162.437,
    y1: 870.82,
    x2: 161.514,
    y2: 871.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_5134_758",
    x1: 198.039,
    y1: 843.75,
    x2: 197.118,
    y2: 844.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_5134_758",
    x1: 272.865,
    y1: 624.764,
    x2: 189.166,
    y2: 700.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_5134_758",
    x1: 171.343,
    y1: 784.237,
    x2: 170.42,
    y2: 785.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_5134_758",
    x1: 325.688,
    y1: 609.125,
    x2: 327.716,
    y2: 609.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_5134_758",
    x1: 286.435,
    y1: 641.923,
    x2: 245.23,
    y2: 678.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_5134_758",
    x1: 238.234,
    y1: 720.148,
    x2: 237.312,
    y2: 721.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_5134_758",
    x1: 312.515,
    y1: 634.408,
    x2: 314.547,
    y2: 634.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_5134_758",
    x1: 261.082,
    y1: 590.719,
    x2: 148.501,
    y2: 698.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_5134_758",
    x1: 340.924,
    y1: 570.221,
    x2: 342.949,
    y2: 570.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_5134_758",
    x1: 120.949,
    y1: 805.341,
    x2: 120.027,
    y2: 806.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_5134_758",
    x1: 190.907,
    y1: 526.787,
    x2: 76.1091,
    y2: 629.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_5134_758",
    x1: 266.944,
    y1: 505.583,
    x2: 268.969,
    y2: 505.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_5134_758",
    x1: 53.6681,
    y1: 746.187,
    x2: 52.745,
    y2: 747.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_5134_758",
    x1: 248.277,
    y1: 580.19,
    x2: 118.14,
    y2: 703.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_5134_758",
    x1: 340.019,
    y1: 556.431,
    x2: 342.051,
    y2: 556.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_5134_758",
    x1: 85.2547,
    y1: 828.381,
    x2: 84.3336,
    y2: 829.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_5134_758",
    x1: 187.527,
    y1: 525.997,
    x2: 47.505,
    y2: 650.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_5134_758",
    x1: 280.654,
    y1: 500.097,
    x2: 282.68,
    y2: 500.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_5134_758",
    x1: 19.8844,
    y1: 793.824,
    x2: 18.9613,
    y2: 794.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_5134_758",
    x1: 211.057,
    y1: 535.922,
    x2: 89.6188,
    y2: 635.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_5134_758",
    x1: 285.759,
    y1: 512.984,
    x2: 287.799,
    y2: 513.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_5134_758",
    x1: 75.4726,
    y1: 770.645,
    x2: 74.5517,
    y2: 771.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_5134_758",
    x1: 304.03,
    y1: 552.962,
    x2: 262.468,
    y2: 602.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_5134_758",
    x1: 340.48,
    y1: 545.67,
    x2: 342.512,
    y2: 545.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_5134_758",
    x1: 237.09,
    y1: 633.369,
    x2: 239.122,
    y2: 633.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_5134_758",
    x1: 280.564,
    y1: 553.649,
    x2: 233.722,
    y2: 610.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_5134_758",
    x1: 322.865,
    y1: 545.409,
    x2: 324.897,
    y2: 545.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_5134_758",
    x1: 203.455,
    y1: 644.632,
    x2: 205.487,
    y2: 644.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_5134_758",
    x1: 257.15,
    y1: 532.926,
    x2: 201.238,
    y2: 580.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_5134_758",
    x1: 292.224,
    y1: 522.601,
    x2: 294.255,
    y2: 522.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_5134_758",
    x1: 193.727,
    y1: 640.753,
    x2: 195.754,
    y2: 640.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_5134_758",
    x1: 296.803,
    y1: 540.02,
    x2: 284.008,
    y2: 556.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_5134_758",
    x1: 308.602,
    y1: 537.908,
    x2: 310.634,
    y2: 537.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_5134_758",
    x1: 273.001,
    y1: 564.999,
    x2: 275.028,
    y2: 565.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_5134_758",
    x1: 243.561,
    y1: 639.831,
    x2: 159.863,
    y2: 715.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_5134_758",
    x1: 299.699,
    y1: 624.491,
    x2: 301.724,
    y2: 624.582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_5134_758",
    x1: 145.352,
    y1: 799.605,
    x2: 144.43,
    y2: 800.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_5134_758",
    x1: 206.73,
    y1: 696.093,
    x2: 165.525,
    y2: 732.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_5134_758",
    x1: 234.115,
    y1: 687.822,
    x2: 233.193,
    y2: 688.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_5134_758",
    x1: 158.523,
    y1: 774.323,
    x2: 157.604,
    y2: 775.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_5134_758",
    x1: 1124.72,
    y1: 396.027,
    x2: 1198.47,
    y2: 698.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_5134_758",
    x1: 1135.56,
    y1: 911.117,
    x2: 1136.02,
    y2: 913.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_5134_758",
    x1: 1017.83,
    y1: 278.45,
    x2: 1014.32,
    y2: 276.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_5134_758",
    x1: 946.561,
    y1: 423.304,
    x2: 1029.88,
    y2: 719.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_5134_758",
    x1: 941.387,
    y1: 940.48,
    x2: 941.856,
    y2: 943.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_5134_758",
    x1: 840.877,
    y1: 305.743,
    x2: 837.364,
    y2: 303.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_5134_758",
    x1: 1108.89,
    y1: 338.835,
    x2: 1195.22,
    y2: 686.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_5134_758",
    x1: 1119.2,
    y1: 933.376,
    x2: 1119.67,
    y2: 936.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_5134_758",
    x1: 982.482,
    y1: 201.247,
    x2: 978.969,
    y2: 199.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_5134_758",
    x1: 964.625,
    y1: 333.008,
    x2: 1066.08,
    y2: 694.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_5134_758",
    x1: 958.605,
    y1: 964.432,
    x2: 959.074,
    y2: 967.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_5134_758",
    x1: 835.176,
    y1: 189.191,
    x2: 831.663,
    y2: 187.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_5134_758",
    x1: 1005.52,
    y1: 407.012,
    x2: 1103.08,
    y2: 705.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_5134_758",
    x1: 981.073,
    y1: 948.218,
    x2: 981.534,
    y2: 950.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_5134_758",
    x1: 903.91,
    y1: 287.993,
    x2: 900.397,
    y2: 285.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_5134_758",
    x1: 1083.5,
    y1: 747.236,
    x2: 1100.69,
    y2: 874.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint280_linear_5134_758",
    x1: 1108.4,
    y1: 952.001,
    x2: 1108.87,
    y2: 954.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint281_linear_5134_758",
    x1: 1028.55,
    y1: 693.067,
    x2: 1029.01,
    y2: 695.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint282_linear_5134_758",
    x1: 1047.75,
    y1: 699.961,
    x2: 1065.91,
    y2: 845.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint283_linear_5134_758",
    x1: 1078.45,
    y1: 933.495,
    x2: 1078.91,
    y2: 936.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint284_linear_5134_758",
    x1: 983.994,
    y1: 637.924,
    x2: 984.454,
    y2: 640.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint285_linear_5134_758",
    x1: 1008.81,
    y1: 689.876,
    x2: 1051.4,
    y2: 830.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint286_linear_5134_758",
    x1: 1002.3,
    y1: 938.967,
    x2: 1002.77,
    y2: 941.666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint287_linear_5134_758",
    x1: 963.432,
    y1: 633.994,
    x2: 963.897,
    y2: 636.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint288_linear_5134_758",
    x1: 1034.91,
    y1: 865.86,
    x2: 1038.56,
    y2: 907.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint289_linear_5134_758",
    x1: 1046.35,
    y1: 930.792,
    x2: 1046.82,
    y2: 933.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint290_linear_5134_758",
    x1: 1015.49,
    y1: 846.9,
    x2: 1015.96,
    y2: 849.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint291_linear_5134_758",
    x1: 1124.95,
    y1: 397.513,
    x2: 1184.06,
    y2: 615.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint292_linear_5134_758",
    x1: 1124.47,
    y1: 775.353,
    x2: 1124.94,
    y2: 778.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint293_linear_5134_758",
    x1: 1052.78,
    y1: 314.358,
    x2: 1049.26,
    y2: 312.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint294_linear_5134_758",
    x1: 1083.63,
    y1: 411.829,
    x2: 1114.1,
    y2: 517.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint295_linear_5134_758",
    x1: 1080.71,
    y1: 595.448,
    x2: 1081.17,
    y2: 598.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint296_linear_5134_758",
    x1: 1047.78,
    y1: 371.119,
    x2: 1044.26,
    y2: 369.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_5134_758",
    x1: 1181.41,
    y1: 352.833,
    x2: 1255.16,
    y2: 655.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_5134_758",
    x1: 1068.95,
    y1: 232.435,
    x2: 1065.44,
    y2: 230.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_5134_758",
    x1: 1186.67,
    y1: 865.104,
    x2: 1187.13,
    y2: 867.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_5134_758",
    x1: 1368.39,
    y1: 320.602,
    x2: 1451.69,
    y2: 616.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_5134_758",
    x1: 1263.1,
    y1: 203.106,
    x2: 1259.59,
    y2: 201.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint302_linear_5134_758",
    x1: 1363.63,
    y1: 837.808,
    x2: 1364.1,
    y2: 840.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint303_linear_5134_758",
    x1: 1214.31,
    y1: 348.867,
    x2: 1300.64,
    y2: 697.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_5134_758",
    x1: 1085.31,
    y1: 210.177,
    x2: 1081.79,
    y2: 208.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint305_linear_5134_758",
    x1: 1222.02,
    y1: 942.307,
    x2: 1222.49,
    y2: 945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint306_linear_5134_758",
    x1: 1374.93,
    y1: 322.906,
    x2: 1476.39,
    y2: 684.066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint307_linear_5134_758",
    x1: 1245.9,
    y1: 179.119,
    x2: 1242.39,
    y2: 177.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint308_linear_5134_758",
    x1: 1369.31,
    y1: 954.393,
    x2: 1369.78,
    y2: 957.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint309_linear_5134_758",
    x1: 1324.62,
    y1: 314.318,
    x2: 1422.18,
    y2: 612.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint310_linear_5134_758",
    x1: 1223.44,
    y1: 195.339,
    x2: 1219.9,
    y2: 193.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint311_linear_5134_758",
    x1: 1300.59,
    y1: 855.561,
    x2: 1301.06,
    y2: 858.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint312_linear_5134_758",
    x1: 1149.67,
    y1: 243.037,
    x2: 1166.85,
    y2: 370.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint313_linear_5134_758",
    x1: 1096.1,
    y1: 191.553,
    x2: 1092.58,
    y2: 189.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint314_linear_5134_758",
    x1: 1175.96,
    y1: 450.486,
    x2: 1172.44,
    y2: 448.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_5134_758",
    x1: 1188.46,
    y1: 269.431,
    x2: 1206.63,
    y2: 414.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_5134_758",
    x1: 1126.06,
    y1: 210.057,
    x2: 1122.54,
    y2: 208.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_5134_758",
    x1: 1220.51,
    y1: 505.633,
    x2: 1216.99,
    y2: 503.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint318_linear_5134_758",
    x1: 1250.19,
    y1: 259.701,
    x2: 1292.8,
    y2: 400.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint319_linear_5134_758",
    x1: 1202.21,
    y1: 204.587,
    x2: 1198.69,
    y2: 202.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint320_linear_5134_758",
    x1: 1241.07,
    y1: 509.56,
    x2: 1237.56,
    y2: 507.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_5134_758",
    x1: 1175.76,
    y1: 229.007,
    x2: 1179.42,
    y2: 270.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint322_linear_5134_758",
    x1: 1158.15,
    y1: 212.76,
    x2: 1154.63,
    y2: 210.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint323_linear_5134_758",
    x1: 1188.99,
    y1: 296.686,
    x2: 1185.48,
    y2: 294.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint324_linear_5134_758",
    x1: 1158.11,
    y1: 454.412,
    x2: 1217.22,
    y2: 672.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint325_linear_5134_758",
    x1: 1080.04,
    y1: 368.196,
    x2: 1076.53,
    y2: 366.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01213A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#B4D1E7",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint326_linear_5134_758",
    x1: 1151.73,
    y1: 829.196,
    x2: 1152.19,
    y2: 831.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint327_linear_5134_758",
    x1: 1159.65,
    y1: 588.805,
    x2: 1190.12,
    y2: 694.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint328_linear_5134_758",
    x1: 1122.41,
    y1: 545.419,
    x2: 1122.87,
    y2: 548.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint329_linear_5134_758",
    x1: 1156.73,
    y1: 772.439,
    x2: 1157.19,
    y2: 775.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1B8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461325,
    stopColor: "#F36F45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B8BC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPattern3);
export default __webpack_public_path__ + "static/media/bg_pattern_3.08bca141ac78ca186814bd77d615e25e.svg";
export { ForwardRef as ReactComponent };